<template>
  <div @click="storeArvore.instanciaSelecionada = instancia">
    <div class="row ms-0 mb-3">
      <div class="col col-12" v-if="storeArvore?.instancias[instancia]?.tipo == 'local' &&
        funcao !== 'selecionar-diretorio' &&
        funcao !== 'selecionar-diretorio-multiplo'
      ">
        <div class="d-flex justify-content-between">
          <div class="d-flex text-start">
            <span tabindex="0" data-bs-toggle="tooltip2" data-bs-placement="top" data-bs-dismiss="click"
              title="Conectar" class="me-2" @click="abrirNuvemConectarDialog()" onclick="this.blur()"
              style="cursor: pointer; margin-top: 7px">
              <!--begin::Svg Icon | path: icons/duotune/arrows/arr078.svg-->
              <span class="svg-icon svg-icon-2">
                <i class="bi bi-pc-display-horizontal fs-2x gx-5 p-2 text-primary"></i>
              </span>
              <!--end::Svg Icon-->
            </span>
            <div>
              <h5>Árvore Local</h5>
              <h5 class="text-muted">
                <small>Arquivos do disco local</small>
              </h5>
            </div>
          </div>
          <div>
            <div :class="{ 'd-none': funcao !== 'padrao' }">
              <button class="btn btn-outline btn-outline-dashed btn-outline-dark btn-active-light-dark me-2 mb-2 px-4"
                data-kt-menu-trigger="{default:'click', lg: 'hover'}" data-kt-menu-attach="parent"
                data-kt-menu-placement="bottom-end">
                <span class="svg-icon svg-icon-2 me-1">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                    class="bi bi-arrow-down-short" viewBox="0 0 16 16">
                    <path fill-rule="evenodd"
                      d="M8 4a.5.5 0 0 1 .5.5v5.793l2.146-2.147a.5.5 0 0 1 .708.708l-3 3a.5.5 0 0 1-.708 0l-3-3a.5.5 0 1 1 .708-.708L7.5 10.293V4.5A.5.5 0 0 1 8 4z" />
                  </svg>
                </span>

                <span class="svg-icon svg-icon-2">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                    class="bi bi-folder-fill" viewBox="0 0 16 16" v-if="storeArvore.instancias[instancia] &&
                      storeArvore.instancias[instancia].view == 'diretorio'
                    ">
                    <path
                      d="M9.828 3h3.982a2 2 0 0 1 1.992 2.181l-.637 7A2 2 0 0 1 13.174 14H2.825a2 2 0 0 1-1.991-1.819l-.637-7a1.99 1.99 0 0 1 .342-1.31L.5 3a2 2 0 0 1 2-2h3.672a2 2 0 0 1 1.414.586l.828.828A2 2 0 0 0 9.828 3zm-8.322.12C1.72 3.042 1.95 3 2.19 3h5.396l-.707-.707A1 1 0 0 0 6.172 2H2.5a1 1 0 0 0-1 .981l.006.139z" />
                  </svg>

                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                    class="bi bi-folder-fill" viewBox="0 0 16 16" v-if="storeArvore.instancias[instancia] &&
                      storeArvore.instancias[instancia].view ==
                      'compartilhamentos'
                    ">
                    <path
                      d="M13.81 3H9.828a2 2 0 0 1-1.414-.586l-.828-.828A2 2 0 0 0 6.172 1H2.5a2 2 0 0 0-2 2l.04.87a1.99 1.99 0 0 0-.342 1.311l.637 7A2 2 0 0 0 2.826 14h10.348a2 2 0 0 0 1.991-1.819l.637-7A2 2 0 0 0 13.81 3zM2.19 3c-.24 0-.47.042-.683.12L1.5 2.98a1 1 0 0 1 1-.98h3.672a1 1 0 0 1 .707.293L7.586 3H2.19zm9.608 5.271-3.182 1.97c-.27.166-.616-.036-.616-.372V9.1s-2.571-.3-4 2.4c.571-4.8 3.143-4.8 4-4.8v-.769c0-.336.346-.538.616-.371l3.182 1.969c.27.166.27.576 0 .742z" />
                  </svg>

                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                    class="bi bi-search" viewBox="0 0 16 16" v-if="storeArvore.instancias[instancia] &&
                      storeArvore.instancias[instancia].view == 'pesquisa'
                    ">
                    <path
                      d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z" />
                  </svg> </span>{{
                    storeArvore.instancias[instancia].view == "diretorio"
                      ? "Pastas"
                      : storeArvore.instancias[instancia].view == "versoes"
                        ? "Versões"
                        : storeArvore.instancias[instancia].view == "excluidos"
                          ? "Excluídos"
                          : storeArvore.instancias[instancia].view == "pesquisa"
                            ? "Filtrar"
                            : ""
                  }}
              </button>
              <div
                class="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-title-gray-700 menu-icon-muted menu-active-bg menu-state-color fw-semibold py-4 fs-base w-175px"
                data-kt-menu="true">
                <!--begin::Menu item-->
                <div class="menu-item px-3 my-0">
                  <span @click="storeArvore.selecionarView(instancia, 'diretorio')" class="menu-link px-3 py-2" :class="{
                    active:
                      storeArvore.instancias[instancia] &&
                      storeArvore.instancias[instancia].view == 'diretorio',
                  }" data-kt-element="mode" data-kt-value="light">
                    <span class="menu-icon" data-kt-element="icon">
                      <!--begin::Svg Icon | path: icons/duotune/general/gen060.svg-->
                      <span class="svg-icon svg-icon-3">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                          class="bi bi-folder-fill" viewBox="0 0 16 16">
                          <path
                            d="M9.828 3h3.982a2 2 0 0 1 1.992 2.181l-.637 7A2 2 0 0 1 13.174 14H2.825a2 2 0 0 1-1.991-1.819l-.637-7a1.99 1.99 0 0 1 .342-1.31L.5 3a2 2 0 0 1 2-2h3.672a2 2 0 0 1 1.414.586l.828.828A2 2 0 0 0 9.828 3zm-8.322.12C1.72 3.042 1.95 3 2.19 3h5.396l-.707-.707A1 1 0 0 0 6.172 2H2.5a1 1 0 0 0-1 .981l.006.139z" />
                        </svg>
                      </span>
                      <!--end::Svg Icon-->
                    </span>
                    <span class="menu-title">Pastas</span>
                  </span>
                </div>
                <!--end::Menu item-->
                <!--begin::Menu item-->
                <div class="menu-item px-3 my-0" :class="{
                  'd-none':
                    storeArvore.instancias[instancia].view !== 'diretorio' &&
                    storeArvore.instancias[instancia].view !==
                    'compartilhamentos' &&
                    storeArvore.instancias[instancia].view !== 'pesquisa',
                }">
                  <span @click="viewPesquisa()" class="menu-link px-3 py-2" :class="{
                    active:
                      storeArvore.instancias[instancia] &&
                      storeArvore?.instancias[instancia]?.view == 'pesquisa',
                  }" data-kt-element="mode" data-kt-value="light">
                    <span class="menu-icon" data-kt-element="icon">
                      <!--begin::Svg Icon | path: icons/duotune/general/gen060.svg-->
                      <span class="svg-icon svg-icon-3">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                          class="bi bi-search" viewBox="0 0 16 16">
                          <path
                            d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z" />
                        </svg>
                      </span>
                      <!--end::Svg Icon-->
                    </span>
                    <span class="menu-title">Pesquisa</span>
                  </span>
                </div>
                <!--end::Menu item-->
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col col-12" v-if="storeArvore?.instancias[instancia]?.tipo == 'remoto' &&
        funcao !== 'selecionar-diretorio' && funcao !== 'pesquisa-global'
      ">
        <div class="d-flex justify-content-between">
          <div class="d-flex text-start">
            <span data-bs-toggle="tooltip2" data-bs-placement="top" data-bs-dismiss="click" title="Conectar"
              class="mt-2 me-2" @click="abrirNuvemConectarDialog()" onclick="this.blur()" style="cursor: pointer">
              <!--begin::Svg Icon | path: icons/duotune/arrows/arr078.svg-->
              <span class="svg-icon svg-icon-2">
                <i class="bi bi-cloud fs-2hx gx-5 p-2 text-primary"></i>
              </span>
              <!--end::Svg Icon-->
            </span>
            <div>
              <h5>
                {{
                  storeAuth.nuvem[instancia] == null
                    ? storeAuth?.sessao.usuario.nuvem.nome
                    : storeAuth?.nuvem[instancia].nome
                }}
              </h5>
              <h5 class="text-muted">
                <small>{{
                  storeAuth.nuvem[instancia] == null
                    ? storeAuth?.sessao.usuario.nomeUsuario
                    : storeAuth?.nuvem[instancia].usuarioNuvem.nomeUsuario
                }}@{{
                    storeAuth.nuvem[instancia] == null
                      ? storeAuth?.sessao.usuario.nuvem.alias
                      : storeAuth?.nuvem[instancia].alias
                  }}</small>
              </h5>
            </div>
            <span class="ms-5 svg-icon svg-icon-2 mt-2" data-bs-toggle="tooltip2" data-bs-placement="top"
              data-bs-dismiss="click" title="Propriedades" v-if="funcao == 'padrao' &&
                ((storeAuth.nuvem[instancia] == null && storeAuth?.sessao.usuario.tipoUsuario == 'adminNuvem') || (storeAuth.nuvem[instancia] !== null && storeAuth?.nuvem[instancia].usuarioNuvem.tipoUsuario == 'adminNuvem'))
              " @click="abrirPropriedades(instancia, true)" style="cursor: pointer" onclick="this.blur()">
              <i class="bi bi-hdd fs-2hx gx-5 p-2 text-primary"></i>
            </span>
            <div class="ms-2" v-if="funcao == 'padrao' &&
              ((storeAuth.nuvem[instancia] == null && storeAuth?.sessao.usuario.tipoUsuario == 'adminNuvem') || (storeAuth.nuvem[instancia] !== null && storeAuth?.nuvem[instancia].usuarioNuvem.tipoUsuario == 'adminNuvem'))
            ">
              <h5>Consumo</h5>
              <h5 class="text-muted">
                <small v-if="storeAuth.nuvem[instancia] == null">{{
                  storeAuth?.sessao.usuario.nuvem.espacoOcupado > 0
                    ? $funcoes.tamanhoTexto(
                      storeAuth?.sessao.usuario.nuvem.espacoOcupado
                    )
                    : 0
                }}
                  de
                  {{
                    storeAuth?.sessao.usuario.nuvem.espacoTotal > 0
                      ? $funcoes.tamanhoTexto(
                        storeAuth?.sessao.usuario.nuvem.espacoTotal
                      )
                      : 0
                  }}</small>
                <small v-if="storeAuth.nuvem[instancia] !== null">{{
                  storeAuth?.nuvem[instancia].espacoOcupado > 0
                    ? $funcoes.tamanhoTexto(
                      storeAuth?.nuvem[instancia].espacoOcupado
                    )
                    : 0
                }}
                  de
                  {{
                    storeAuth?.nuvem[instancia].espacoTotal > 0
                      ? $funcoes.tamanhoTexto(
                        storeAuth?.nuvem[instancia].espacoTotal
                      )
                      : 0
                  }}</small>
              </h5>
            </div>
          </div>
          <div>
            <div :class="{ 'd-none': funcao !== 'padrao' }">
              <button class="btn btn-outline btn-outline-dashed btn-outline-dark btn-active-light-dark me-2 mb-2 px-4"
                data-kt-menu-trigger="{default:'click', lg: 'hover'}" data-kt-menu-attach="parent"
                data-kt-menu-placement="bottom-end">
                <span class="svg-icon svg-icon-2 me-1">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                    class="bi bi-arrow-down-short" viewBox="0 0 16 16">
                    <path fill-rule="evenodd"
                      d="M8 4a.5.5 0 0 1 .5.5v5.793l2.146-2.147a.5.5 0 0 1 .708.708l-3 3a.5.5 0 0 1-.708 0l-3-3a.5.5 0 1 1 .708-.708L7.5 10.293V4.5A.5.5 0 0 1 8 4z" />
                  </svg>
                </span>
                <span class="svg-icon svg-icon-2">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                    class="bi bi-folder-fill" viewBox="0 0 16 16" v-if="storeArvore.instancias[instancia] &&
                      storeArvore.instancias[instancia].view == 'diretorio'
                    ">
                    <path
                      d="M9.828 3h3.982a2 2 0 0 1 1.992 2.181l-.637 7A2 2 0 0 1 13.174 14H2.825a2 2 0 0 1-1.991-1.819l-.637-7a1.99 1.99 0 0 1 .342-1.31L.5 3a2 2 0 0 1 2-2h3.672a2 2 0 0 1 1.414.586l.828.828A2 2 0 0 0 9.828 3zm-8.322.12C1.72 3.042 1.95 3 2.19 3h5.396l-.707-.707A1 1 0 0 0 6.172 2H2.5a1 1 0 0 0-1 .981l.006.139z" />
                  </svg>

                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                    class="bi bi-folder-fill" viewBox="0 0 16 16" v-if="storeArvore.instancias[instancia] &&
                      storeArvore.instancias[instancia].view ==
                      'compartilhamentos'
                    ">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                      class="bi bi-folder-symlink-fill" viewBox="0 0 16 16">
                      <path
                        d="M13.81 3H9.828a2 2 0 0 1-1.414-.586l-.828-.828A2 2 0 0 0 6.172 1H2.5a2 2 0 0 0-2 2l.04.87a1.99 1.99 0 0 0-.342 1.311l.637 7A2 2 0 0 0 2.826 14h10.348a2 2 0 0 0 1.991-1.819l.637-7A2 2 0 0 0 13.81 3zM2.19 3c-.24 0-.47.042-.683.12L1.5 2.98a1 1 0 0 1 1-.98h3.672a1 1 0 0 1 .707.293L7.586 3H2.19zm9.608 5.271-3.182 1.97c-.27.166-.616-.036-.616-.372V9.1s-2.571-.3-4 2.4c.571-4.8 3.143-4.8 4-4.8v-.769c0-.336.346-.538.616-.371l3.182 1.969c.27.166.27.576 0 .742z" />
                    </svg>
                  </svg>

                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                    class="bi bi-badge-vr-fill" viewBox="0 0 16 16" v-if="storeArvore.instancias[instancia] &&
                      storeArvore.instancias[instancia].view == 'versoes'
                    ">
                    <path d="M9.673 5.933v1.938h1.033c.66 0 1.068-.316 1.068-.95 0-.64-.422-.988-1.05-.988h-1.05z" />
                    <path
                      d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4zm5.937 7 1.99-5.999H6.61L5.277 9.708H5.22L3.875 5.001H2.5L4.508 11h1.429zM8.5 5.001V11h1.173V8.763h1.064L11.787 11h1.327L11.91 8.583C12.455 8.373 13 7.779 13 6.9c0-1.147-.773-1.9-2.105-1.9H8.5z" />
                  </svg>
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                    class="bi bi-trash-fill" viewBox="0 0 16 16" v-if="storeArvore.instancias[instancia] &&
                      storeArvore.instancias[instancia].view == 'excluidos'
                    ">
                    <path
                      d="M2.5 1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1H3v9a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4h.5a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H10a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1H2.5zm3 4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5zM8 5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7A.5.5 0 0 1 8 5zm3 .5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 1 0z" />
                  </svg>
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                    class="bi bi-search" viewBox="0 0 16 16" v-if="storeArvore.instancias[instancia] &&
                      storeArvore.instancias[instancia].view == 'pesquisa'
                    ">
                    <path
                      d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z" />
                  </svg> </span>{{
                    storeArvore.instancias[instancia].view == "diretorio"
                      ? "Pastas"
                      : storeArvore.instancias[instancia].view == "versoes"
                        ? "Versões"
                        : storeArvore.instancias[instancia].view == "excluidos"
                          ? "Excluídos"
                          : storeArvore.instancias[instancia].view == "pesquisa"
                            ? "Filtrar"
                            : storeArvore.instancias[instancia].view ==
                              "compartilhamentos"
                              ? "Compartilhamentos"
                              : ""
                  }}
              </button>
              <div
                class="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-title-gray-700 menu-icon-muted menu-active-bg menu-state-color fw-semibold py-4 fs-base w-200px"
                data-kt-menu="true">
                <!--begin::Menu item-->
                <div class="menu-item px-3 my-0">
                  <span @click="storeArvore.selecionarView(instancia, 'diretorio')" class="menu-link px-3 py-2" :class="{
                    active:
                      storeArvore.instancias[instancia] &&
                      storeArvore.instancias[instancia].view == 'diretorio',
                  }" data-kt-element="mode" data-kt-value="light"
                    v-if="(storeAuth.nuvem[instancia] == null && storeAuth?.sessao.usuario.tipoUsuario == 'adminNuvem') || (storeAuth.nuvem[instancia] !== null && storeAuth?.nuvem[instancia].usuarioNuvem.tipoUsuario == 'adminNuvem')">
                    <span class="menu-icon" data-kt-element="icon">
                      <!--begin::Svg Icon | path: icons/duotune/general/gen060.svg-->
                      <span class="svg-icon svg-icon-3">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                          class="bi bi-folder-fill" viewBox="0 0 16 16">
                          <path
                            d="M9.828 3h3.982a2 2 0 0 1 1.992 2.181l-.637 7A2 2 0 0 1 13.174 14H2.825a2 2 0 0 1-1.991-1.819l-.637-7a1.99 1.99 0 0 1 .342-1.31L.5 3a2 2 0 0 1 2-2h3.672a2 2 0 0 1 1.414.586l.828.828A2 2 0 0 0 9.828 3zm-8.322.12C1.72 3.042 1.95 3 2.19 3h5.396l-.707-.707A1 1 0 0 0 6.172 2H2.5a1 1 0 0 0-1 .981l.006.139z" />
                        </svg>
                      </span>
                      <!--end::Svg Icon-->
                    </span>
                    <span class="menu-title">Pastas</span>
                  </span>
                </div>
                <!--end::Menu item-->
                <!--begin::Menu item-->
                <div class="menu-item px-3 my-0" v-if="true">
                  <span @click="
                    storeArvore.selecionarView(instancia, 'compartilhamentos')
                    " class="menu-link px-3 py-2" :class="{
                      active:
                        storeArvore.instancias[instancia] &&
                        storeArvore.instancias[instancia].view ==
                        'compartilhamentos',
                    }" data-kt-element="mode" data-kt-value="light">
                    <span class="menu-icon" data-kt-element="icon">
                      <!--begin::Svg Icon | path: icons/duotune/general/gen060.svg-->
                      <span class="svg-icon svg-icon-3">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                          class="bi bi-folder-fill" viewBox="0 0 16 16">
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                            class="bi bi-folder-symlink-fill" viewBox="0 0 16 16">
                            <path
                              d="M13.81 3H9.828a2 2 0 0 1-1.414-.586l-.828-.828A2 2 0 0 0 6.172 1H2.5a2 2 0 0 0-2 2l.04.87a1.99 1.99 0 0 0-.342 1.311l.637 7A2 2 0 0 0 2.826 14h10.348a2 2 0 0 0 1.991-1.819l.637-7A2 2 0 0 0 13.81 3zM2.19 3c-.24 0-.47.042-.683.12L1.5 2.98a1 1 0 0 1 1-.98h3.672a1 1 0 0 1 .707.293L7.586 3H2.19zm9.608 5.271-3.182 1.97c-.27.166-.616-.036-.616-.372V9.1s-2.571-.3-4 2.4c.571-4.8 3.143-4.8 4-4.8v-.769c0-.336.346-.538.616-.371l3.182 1.969c.27.166.27.576 0 .742z" />
                          </svg>
                        </svg>
                      </span>
                      <!--end::Svg Icon-->
                    </span>
                    <span class="menu-title">Compartilhamentos</span>
                  </span>
                </div>
                <!--end::Menu item-->
                <!--begin::Menu item-->
                <div class="menu-item px-3 my-0">
                  <span @click="
                    storeArvore.isSelecionadoArquivo(instancia) == true &&
                      (storeArvore?.instancias[instancia]?.view ==
                        'diretorio' ||
                        storeArvore?.instancias[instancia]?.view == 'pesquisa' ||
                        storeArvore?.instancias[instancia]?.view == 'compartilhamentos')
                      ? storeArvore.versoes(instancia)
                      : false
                    " class="menu-link px-3 py-2" :class="{
                      active:
                        storeArvore.instancias[instancia] &&
                        storeArvore.instancias[instancia].view == 'versoes',
                    }"
                    v-if="(storeAuth.nuvem[instancia] == null && storeAuth?.sessao.usuario.tipoUsuario == 'adminNuvem') || (storeAuth.nuvem[instancia] !== null && storeAuth?.nuvem[instancia].usuarioNuvem.tipoUsuario == 'adminNuvem')">
                    <span class="menu-icon" data-kt-element="icon">
                      <!--begin::Svg Icon | path: icons/duotune/general/gen061.svg-->
                      <span class="svg-icon svg-icon-3">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                          class="bi bi-badge-vr-fill" viewBox="0 0 16 16">
                          <path
                            d="M9.673 5.933v1.938h1.033c.66 0 1.068-.316 1.068-.95 0-.64-.422-.988-1.05-.988h-1.05z" />
                          <path
                            d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4zm5.937 7 1.99-5.999H6.61L5.277 9.708H5.22L3.875 5.001H2.5L4.508 11h1.429zM8.5 5.001V11h1.173V8.763h1.064L11.787 11h1.327L11.91 8.583C12.455 8.373 13 7.779 13 6.9c0-1.147-.773-1.9-2.105-1.9H8.5z" />
                        </svg>
                      </span>
                      <!--end::Svg Icon-->
                    </span>
                    <span class="menu-title">Versões</span>
                  </span>
                </div>
                <!--end::Menu item-->
                <!--begin::Menu item-->
                <div class="menu-item px-3 my-0">
                  <span class="menu-link px-3 py-2" :class="{
                    active:
                      storeArvore.instancias[instancia] &&
                      storeArvore.instancias[instancia].view == 'excluidos',
                  }" @click="storeArvore.excluidos(instancia)"
                    v-if="(storeAuth.nuvem[instancia] == null && storeAuth?.sessao.usuario.tipoUsuario == 'adminNuvem') || (storeAuth.nuvem[instancia] !== null && storeAuth?.nuvem[instancia].usuarioNuvem.tipoUsuario == 'adminNuvem')">
                    <span class="menu-icon" data-kt-element="icon">
                      <!--begin::Svg Icon | path: icons/duotune/general/gen062.svg-->
                      <span class="svg-icon svg-icon-3">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                          class="bi bi-trash-fill" viewBox="0 0 16 16">
                          <path
                            d="M2.5 1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1H3v9a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4h.5a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H10a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1H2.5zm3 4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5zM8 5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7A.5.5 0 0 1 8 5zm3 .5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 1 0z" />
                        </svg>
                      </span>
                      <!--end::Svg Icon-->
                    </span>
                    <span class="menu-title">Excluídos</span>
                  </span>
                </div>
                <!--end::Menu item-->
                <!--begin::Menu item-->
                <div class="menu-item px-3 my-0" :class="{
                  'd-none':
                    storeArvore.instancias[instancia].view !== 'diretorio' &&
                    storeArvore.instancias[instancia].view !==
                    'compartilhamentos' &&
                    storeArvore.instancias[instancia].view !== 'pesquisa',
                }">
                  <span @click="viewPesquisa()" class="menu-link px-3 py-2" :class="{
                    active:
                      storeArvore.instancias[instancia] &&
                      storeArvore?.instancias[instancia]?.view == 'pesquisa',
                  }" data-kt-element="mode" data-kt-value="light">
                    <span class="menu-icon" data-kt-element="icon">
                      <!--begin::Svg Icon | path: icons/duotune/general/gen060.svg-->
                      <span class="svg-icon svg-icon-3">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                          class="bi bi-search" viewBox="0 0 16 16">
                          <path
                            d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z" />
                        </svg>
                      </span>
                      <!--end::Svg Icon-->
                    </span>
                    <span class="menu-title">Filtrar</span>
                  </span>
                </div>
                <!--end::Menu item-->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row gy-5 g-xl-8">
      <div class="col-xl-12">
        <div class="mb-5 mb-xl-8" :class="{ 'card card-xl-stretch ': funcao == 'padrao' }">
          <div class="py-0 px-1" :class="{ 'card-body': funcao == 'padrao' }">

            <!-- Toolbar -->
            <DiretorioListToolbar
              :instancia="instancia"
              :funcao="funcao"
              :appTipo="$funcoes.appTipo()"
              :tipo="storeArvore?.instancias[instancia]?.tipo"
              :view="storeArvore?.instancias[instancia]?.view"
              :diretorioAtual="storeArvore?.instancias[instancia]?.diretorioAtual"
              :diretorioExcluidoRoot="storeArvore?.instancias[instancia]?.diretorioExcluidoRoot"
              :selecionadosQtd="storeArvore.selecionadosQuantidade(instancia)"
              :isSelecionadoArquivo="storeArvore.isSelecionadoArquivo(instancia)"
              :clipboardVazio="storeArvore.clipboard == null"
              :copiarQtd="storeArvore.clipboard?.copiar?.instancia === instancia ? (storeArvore.clipboard?.copiar?.itens?.length || 0) : 0"
              :recortarQtd="storeArvore.clipboard?.recortar?.instancia === instancia ? (storeArvore.clipboard?.recortar?.itens?.length || 0) : 0"
              :itensTotal="storeArvore?.instancias[instancia]?.itensTotal"
              :tipoUsuario="storeAuth?.sessao?.usuario?.tipoUsuario"
              @transferir="storeArvore.transferir(instancia)"
              @abrir-filtro="abrirFiltro(instancia)"
              @abrir-procurar="abrirProcurar(instancia)"
              @propriedades="menuPropriedades()"
              @restaurar="restaurarConfirmar()"
              @nova-pasta="storeArvore.diretorioCriar(instancia)"
              @excluir="excluirItem()"
              @excluir-permanente="excluirPermanenteConfirmar()"
              @renomear="storeArvore.renomear(instancia)"
              @recortar="storeArvore.recortar(instancia)"
              @copiar="storeArvore.copiar(instancia)"
              @colar="storeArvore.colar(instancia)"
              @abrir-local="storeArvore.abrirArquivoOS(instancia)"
              @abrir-arquivo="abrirArquivo()"
              @atualizar="storeArvore.atualizar(instancia)"
              @pasta-acima="pastaAcima(instancia)"
              @pasta-anterior="pastaAnterior(instancia)"
              @upload="abrirDialogUpload()"
              @download="storeArvore.downloadAnexo(instancia)"
              @link="abrirDialogLinkOpcoes()"
              @exportar="exportarAbrir()"
            />

            <div class="m-3 text-center" v-if="storeArvore?.instancias[instancia]?.funcao ==
              'selecionar-diretorio' ||
              storeArvore?.instancias[instancia]?.funcao ==
              'selecionar-diretorio-multiplo'
            ">
              <button class="btn btn-light-primary" @click="storeArvore.diretorioCriar(instancia)">
                <span class="svg-icon svg-icon-1">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                    class="bi bi-folder-plus" viewBox="0 0 16 16">
                    <path
                      d="m.5 3 .04.87a1.99 1.99 0 0 0-.342 1.311l.637 7A2 2 0 0 0 2.826 14H9v-1H2.826a1 1 0 0 1-.995-.91l-.637-7A1 1 0 0 1 2.19 4h11.62a1 1 0 0 1 .996 1.09L14.54 8h1.005l.256-2.819A2 2 0 0 0 13.81 3H9.828a2 2 0 0 1-1.414-.586l-.828-.828A2 2 0 0 0 6.172 1H2.5a2 2 0 0 0-2 2zm5.672-1a1 1 0 0 1 .707.293L7.586 3H2.19c-.24 0-.47.042-.683.12L1.5 2.98a1 1 0 0 1 1-.98h3.672z">
                    </path>
                    <path
                      d="M13.5 10a.5.5 0 0 1 .5.5V12h1.5a.5.5 0 1 1 0 1H14v1.5a.5.5 0 1 1-1 0V13h-1.5a.5.5 0 0 1 0-1H13v-1.5a.5.5 0 0 1 .5-.5z">
                    </path>
                  </svg>
                </span>
                Nova Pasta
              </button>
            </div>

            <div class="row m-2"
              v-if="storeArvore?.instancias[instancia]?.funcao !== 'pesquisa-global' && storeArvore?.instancias[instancia]?.view == 'pesquisa'">
              <div class="col col-md-12 col-sm-12 col-xs-12">
                <div class="input-group input-group-sm">
                  <span class="input-group-text" id="basic-addon1"><i class="bi bi-search"></i></span>
                  <input type="text" class="form-control" ref="filtroNome" v-if="storeArvore.instancias[instancia]"
                    v-model="storeArvore.instancias[instancia].filtroNome" @keyup="enterBarraIrManual" />
                </div>
              </div>
            </div>

            <div class="m-3 position-relative" v-if="storeArvore?.instancias[instancia]?.funcao !== 'pesquisa-global'">
              <div class="input-group path-input-group">
                <span class="input-group-text cursor-pointer" id="barraPathOpcoesMostrar" 
                  :class="{ 'disabled': storeArvore?.instancias[instancia]?.view == 'versoes' }"
                  @click="storeArvore?.instancias[instancia]?.view !== 'versoes' && (storeArvore.instancias[instancia].barraPathOpcoesMostrar = !storeArvore.instancias[instancia].barraPathOpcoesMostrar)">
                  <i id="barraPathOpcoesMostrarIcone" class="bi bi-clock-history"></i>
                </span>
                <input autocomplete="off" type="text" class="form-control" id="inputBarraPath"
                  v-if="storeArvore.instancias[instancia]" v-model="storeArvore.instancias[instancia].barraPath"
                  :instancia="instancia" 
                  :disabled="storeArvore?.instancias[instancia]?.view == 'versoes'"
                  :readonly="storeArvore?.instancias[instancia]?.view == 'versoes'"
                  @blur="blurBarraIr" @keyup="enterBarraIr" @focus="
                    storeArvore?.instancias[instancia]?.view !== 'versoes' && (storeArvore.instancias[
                      instancia
                    ].barraPathOpcoesMostrar = true)
                    " />
              </div>
              
              <!-- Dropdown de histórico de paths -->
              <div class="path-history-dropdown" 
                v-if="storeArvore.instancias[instancia]?.barraPathOpcoesMostrar && Object.keys(storeArvore.instancias[instancia]?.barraPathOpcoes || {}).length > 0"
                ref="barraPathOpcao" 
                :id="'barraPathOpcao_' + instancia">
                <div class="path-history-header">
                  <i class="bi bi-clock-history me-2"></i>
                  <span>Histórico de navegação</span>
                  <button type="button" class="btn-close btn-close-sm ms-auto" 
                    @click="storeArvore.instancias[instancia].barraPathOpcoesMostrar = false"></button>
                </div>
                <div class="path-history-list">
                  <template v-for="(barraPathOpcaoKey, barraPathOpcaoIndex) in Object.keys(storeArvore.instancias[instancia].barraPathOpcoes).reverse()" 
                    :key="barraPathOpcaoKey">
                    <div v-if="storeArvore.instancias[instancia].barraPathOpcoes[barraPathOpcaoKey].path && storeArvore.instancias[instancia].barraPathOpcoes[barraPathOpcaoKey].path.trim() !== '' && storeArvore.instancias[instancia].barraPathOpcoes[barraPathOpcaoKey].path !== '/'"
                      class="path-history-item"
                      @click="barraPathOpcaoClique(storeArvore.instancias[instancia].barraPathOpcoes[barraPathOpcaoKey])">
                      <i class="bi bi-folder2 me-2"></i>
                      <span class="path-history-text">{{ storeArvore.instancias[instancia].barraPathOpcoes[barraPathOpcaoKey].path }}</span>
                    </div>
                  </template>
                </div>
              </div>
            </div>

            <div class="row position-relative">
              <div class="col">
                <div ref="frameDiretorio" class="table-responsive py-0 px-2 m-1 mt-0 ps-3"
                  :class="{ 
                    'frameDiretorioFixed': storeArvore?.instancias[instancia]?.funcao !== 'pesquisa-global',
                    'drag-over': dragState.isDragOver 
                  }"
                  @contextmenu.prevent="abrirMenuContextoTabela($event)"
                  @click="limparSelecaoAreaVazia($event)"
                  @dragenter.prevent="handleDragEnter($event)"
                  @dragover.prevent="handleDragOver($event)"
                  @dragleave.prevent="handleDragLeave($event)"
                  @drop.prevent="handleDrop($event)">
                  <table class="table table-resizable" ref="tabelaDiretorio">
                    <thead>
                      <tr class="fw-bolder text-muted">
                        <th class="text-start w-25px ps-4 py-3" v-if="funcao == 'selecionar-diretorio-multiplo'"></th>
                        <th class="text-start py-3 ps-3 resizable" style="width: 40%"
                          :class="{ 'cursor-pointer': storeArvore?.instancias[instancia]?.view !== 'versoes' }"
                          @click="handleHeaderClick($event, 'nome_ASC', 'nome_DESC')" v-if="(funcao == 'padrao' || funcao == 'pesquisa-global') &&
                            (storeArvore?.instancias[instancia]?.view ==
                              'diretorio' ||
                              storeArvore?.instancias[instancia]?.view ==
                              'compartilhamentos' ||
                              storeArvore?.instancias[instancia]?.view ==
                              'pesquisa' ||
                              storeArvore?.instancias[instancia]?.view ==
                              'excluidos')
                          ">
                          Itens ({{
                            storeArvore?.instancias[instancia]?.itensTotal
                          }}) <i v-if="storeArvore?.instancias[instancia]?.view !== 'versoes'" class="bi"
                            :class="{ 'bi-sort-down-alt': storeArvore?.instancias[instancia]?.ordem == 'nome_ASC', 'bi-sort-up': storeArvore?.instancias[instancia]?.ordem == 'nome_DESC' }"></i>
                          <div class="resize-handle" @pointerdown.stop.prevent="iniciarResize($event, 0)" @mousedown.stop.prevent="iniciarResize($event, 0)"></div>
                        </th>
                        <th class="text-start py-3 ps-3 resizable" style="width: 40%"
                          :class="{ 'cursor-pointer': storeArvore?.instancias[instancia]?.view !== 'versoes' }"
                          @click="handleHeaderClick($event, 'versoes_ASC', 'versoes_DESC')" v-if="funcao == 'padrao' &&
                            storeArvore?.instancias[instancia]?.view ==
                            'versoes'
                          ">
                          Versões ({{
                            storeArvore?.instancias[instancia]?.itensTotal
                          }}) <i v-if="storeArvore?.instancias[instancia]?.view !== 'versoes'" class="bi"
                            :class="{ 'bi-sort-down-alt': storeArvore?.instancias[instancia]?.ordem == 'versoes_ASC', 'bi-sort-up': storeArvore?.instancias[instancia]?.ordem == 'versoes_DESC' }"></i>
                          <div class="resize-handle" @pointerdown.stop.prevent="iniciarResize($event, 0)" @mousedown.stop.prevent="iniciarResize($event, 0)"></div>
                        </th>
                        <th class="text-start py-3 ps-2 resizable" style="width: 100px"
                          :class="{ 'cursor-pointer': storeArvore?.instancias[instancia]?.view !== 'versoes' }"
                          @click="handleHeaderClick($event, 'tamanho_ASC', 'tamanho_DESC')"
                          v-if="(funcao == 'padrao' || funcao == 'pesquisa-global')">
                          Tamanho <i v-if="storeArvore?.instancias[instancia]?.view !== 'versoes'" class="bi"
                            :class="{ 'bi-sort-down-alt': storeArvore?.instancias[instancia]?.ordem == 'tamanho_ASC', 'bi-sort-up': storeArvore?.instancias[instancia]?.ordem == 'tamanho_DESC' }"></i>
                          <div class="resize-handle" @pointerdown.stop.prevent="iniciarResize($event, 1)" @mousedown.stop.prevent="iniciarResize($event, 1)"></div>
                        </th>
                        <th class="text-start py-3 ps-2 resizable" style="width: 150px"
                          :class="{ 'cursor-pointer': storeArvore?.instancias[instancia]?.view !== 'versoes' }"
                          @click="handleHeaderClick($event, 'dataAlteracao_ASC', 'dataAlteracao_DESC')"
                          v-if="(funcao == 'padrao' || funcao == 'pesquisa-global')">
                          Data <i v-if="storeArvore?.instancias[instancia]?.view !== 'versoes'" class="bi"
                            :class="{ 'bi-sort-down-alt': storeArvore?.instancias[instancia]?.ordem == 'dataAlteracao_ASC', 'bi-sort-up': storeArvore?.instancias[instancia]?.ordem == 'dataAlteracao_DESC' }"></i>
                          <div class="resize-handle" @pointerdown.stop.prevent="iniciarResize($event, 2)" @mousedown.stop.prevent="iniciarResize($event, 2)"></div>
                        </th>
                        <th class="text-start py-3 ps-2 resizable" style="width: 150px"
                          :class="{ 'cursor-pointer': storeArvore?.instancias[instancia]?.view !== 'versoes' }"
                          @click="handleHeaderClick($event, 'dataExclusao_ASC', 'dataExclusao_DESC')"
                          v-if="(funcao == 'padrao' || funcao == 'pesquisa-global') &&
                            storeArvore?.instancias[instancia]?.view == 'excluidos'">
                          Data Exclusão <i v-if="storeArvore?.instancias[instancia]?.view !== 'versoes'" class="bi"
                            :class="{ 'bi-sort-down-alt': storeArvore?.instancias[instancia]?.ordem == 'dataExclusao_ASC', 'bi-sort-up': storeArvore?.instancias[instancia]?.ordem == 'dataExclusao_DESC' }"></i>
                          <div class="resize-handle" @pointerdown.stop.prevent="iniciarResize($event, 2)" @mousedown.stop.prevent="iniciarResize($event, 2)"></div>
                        </th>
                        <th class="text-start py-3 ps-2 resizable" style="width: 150px"
                          v-if="(funcao == 'padrao' || funcao == 'pesquisa-global') &&
                            storeArvore?.instancias[instancia]?.view == 'excluidos'">
                          Usuário Exclusão
                          <div class="resize-handle" @pointerdown.stop.prevent="iniciarResize($event, 2)" @mousedown.stop.prevent="iniciarResize($event, 2)"></div>
                        </th>
                        <th class="text-start py-3 ps-2 resizable" style="width: 80px"
                          :class="{ 'cursor-pointer': storeArvore?.instancias[instancia]?.view !== 'versoes' }"
                          @click="handleHeaderClick($event, 'tipo_ASC', 'tipo_DESC')"
                          v-if="(funcao == 'padrao' || funcao == 'pesquisa-global')">
                          Tipo <i v-if="storeArvore?.instancias[instancia]?.view !== 'versoes'" class="bi"
                            :class="{ 'bi-sort-down-alt': storeArvore?.instancias[instancia]?.ordem == 'tipo_ASC', 'bi-sort-up': storeArvore?.instancias[instancia]?.ordem == 'tipo_DESC' }"></i>
                          <div class="resize-handle" @pointerdown.stop.prevent="iniciarResize($event, 3)" @mousedown.stop.prevent="iniciarResize($event, 3)"></div>
                        </th>
                        <th class="text-start py-3 ps-2 resizable" style="width: 80px"
                          :class="{ 'cursor-pointer': storeArvore?.instancias[instancia]?.view !== 'versoes' }"
                          @click="handleHeaderClick($event, 'versoesQuantidade_ASC', 'versoesQuantidade_DESC')" v-if="(funcao == 'padrao' || funcao == 'pesquisa-global') &&
                            storeArvore?.instancias[instancia]?.tipo ==
                            'remoto' &&
                            (storeArvore?.instancias[instancia]?.view ==
                              'diretorio' ||
                              storeArvore?.instancias[instancia]?.view ==
                              'compartilhamentos' ||
                              storeArvore?.instancias[instancia]?.view ==
                              'pesquisa' ||
                              storeArvore?.instancias[instancia]?.view ==
                              'excluidos')
                          ">
                          Versões <i v-if="storeArvore?.instancias[instancia]?.view !== 'versoes'" class="bi"
                            :class="{ 'bi-sort-down-alt': storeArvore?.instancias[instancia]?.ordem == 'versoesQuantidade_ASC', 'bi-sort-up': storeArvore?.instancias[instancia]?.ordem == 'versoesQuantidade_DESC' }"></i>
                          <div class="resize-handle" @pointerdown.stop.prevent="iniciarResize($event, 4)" @mousedown.stop.prevent="iniciarResize($event, 4)"></div>
                        </th>
                        <th class="text-start py-3 ps-2 resizable" style="width: 80px" v-if="funcao == 'padrao' &&
                          storeArvore?.instancias[instancia]?.tipo ==
                          'remoto' &&
                          storeArvore?.instancias[instancia]?.view ==
                          'versoes'
                        ">
                          Versão <i v-if="storeArvore?.instancias[instancia]?.view !== 'versoes'" class="bi"
                            :class="{ 'bi-sort-down-alt': storeArvore?.instancias[instancia]?.ordem == 'versao_ASC', 'bi-sort-up': storeArvore?.instancias[instancia]?.ordem == 'versao_DESC' }"></i>
                          <div class="resize-handle" @pointerdown.stop.prevent="iniciarResize($event, 4)" @mousedown.stop.prevent="iniciarResize($event, 4)"></div>
                        </th>
                      </tr>
                    </thead>

                    <tbody class="text-center" :class="{
                      'd-none':
                        !storeArvore?.instancias[instancia]?.carregandoItens,
                    }">
                      <tr>
                        <td colspan="10">
                          <div class="spinner-border text-primary mt-5" role="status"></div>

                          <div class="text-gray-800 fs-6 fw-semibold mt-3">
                            Carregando ...
                          </div>
                        </td>
                      </tr>
                    </tbody>

                    <tbody class="text-center" :class="{
                      'd-none':
                        storeArvore?.instancias[instancia]?.funcao !== 'pesquisa-global' || storeArvore?.instancias[instancia]?.carregandoItens || storeArvore?.instancias[instancia]?.itens.length > 0 || storeArvore?.instancias[instancia]?.filtroDefinido == true,
                    }">
                      <tr>
                        <td colspan="10">
                          <div class="text-gray-800 fs-6 fw-semibold mt-6 mb-0 ">
                            
                            <button class="btn btn-link pb-0 text-muted text-hover-primary fw-normal" @click="abrirFiltro(instancia)">Selecione pelo menos um filtro</button>
                          </div>
                        </td>
                      </tr>
                    </tbody>

                    <tbody
                      v-if="!storeArvore?.instancias[instancia]?.carregandoItens"
                      @contextmenu.prevent="abrirMenuContextoTabela($event)"
                    >
                      <tr
                        v-for="(item, index) in storeArvore?.instancias[instancia]?.itens || []"
                        :key="item._id"
                        v-memo="[item._id, storeArvore.isSelecionado(instancia, item._id), item.status, dragState.isDragging, storeAuth.usuarios]"
                        :class="{
                          'bg-primary-light': storeArvore.isSelecionado(instancia, item._id),
                          'bg-hover-primary-light': true,
                          'dragging': dragState.isDragging && storeArvore.isSelecionado(instancia, item._id)
                        }"
                        :id="'itemDiretorio_' + instancia + '_' + index"
                        :draggable="!item.isDiretorioPai && !item.status && storeArvore?.instancias[instancia]?.view !== 'versoes'"
                        @dragstart="handleRowDragStart($event, item, index)"
                        @dragend="handleRowDragEnd($event)"
                        @dblclick="duploCliqueItem(instancia,item)"
                        @click="storeArvore.selecionar($event, instancia, item, index)"
                        @contextmenu.prevent.stop="abrirMenuContexto($event, item, index)"
                      >
                        <td v-if="funcao == 'selecionar-diretorio-multiplo'" class="ps-4 py-2">
                          <span class="form-check form-check-custom form-check-sm"
                            v-if="!item.isArquivo && !item.isDiretorioPai">
                            <input class="form-check-input" type="checkbox" @change="selecaoMultipla(item, $event)"
                              :checked="storeArvore.instancias[instancia]
                                .selecaoMultipla[item._id]
                                " />
                          </span>
                        </td>
                        <td class="ps-2 pe-2" v-if="item.status &&
                          (item.status == 'diretorio-novo' ||
                            item.status == 'renomear')
                        " :colspan="storeArvore?.instancias[instancia]?.tipo == 'local'
                          ? '4'
                          : '5'
                          ">
                          <div>
                            <div v-if="item.status == 'diretorio-novo'">
                              <div class="d-flex">
                                <span class="align-self-center svg-icon svg-icon-2x svg-icon-primary me-3"
                                  v-if="!item.tipo">
                                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none">
                                    <path opacity="0.3" d="M10 4H21C21.6 4 22 4.4 22 5V7H10V4Z" fill="currentColor">
                                    </path>
                                    <path
                                      d="M9.2 3H3C2.4 3 2 3.4 2 4V19C2 19.6 2.4 20 3 20H21C21.6 20 22 19.6 22 19V7C22 6.4 21.6 6 21 6H12L10.4 3.60001C10.2 3.20001 9.7 3 9.2 3Z"
                                      fill="currentColor"></path>
                                  </svg>
                                </span>
                                <input type="text" placeholder="Nome do diretório" class="form-control me-3"
                            v-model="item.nome" @keyup="
                                    enterDiretorioSalvar(
                                      $event,
                                      instancia,
                                      index,
                                      item
                                    )
                                    " />
                                <button class="btn btn-icon btn-light-primary me-3 w-65px"
                                  id="kt_file_manager_add_folder" @click="
                                  storeArvore.diretorioSalvar(
                                      instancia,
                                      index,
                                      item
                                    )
                                    ">
                                  <span class="indicator-label">
                                    <!--begin::Svg Icon | path: icons/duotune/arrows/arr085.svg-->
                                    <span class="svg-icon svg-icon-1">
                                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path
                                          d="M9.89557 13.4982L7.79487 11.2651C7.26967 10.7068 6.38251 10.7068 5.85731 11.2651C5.37559 11.7772 5.37559 12.5757 5.85731 13.0878L9.74989 17.2257C10.1448 17.6455 10.8118 17.6455 11.2066 17.2257L18.1427 9.85252C18.6244 9.34044 18.6244 8.54191 18.1427 8.02984C17.6175 7.47154 16.7303 7.47154 16.2051 8.02984L11.061 13.4982C10.7451 13.834 10.2115 13.834 9.89557 13.4982Z"
                                          fill="currentColor"></path>
                                      </svg>
                                    </span>
                                    <!--end::Svg Icon-->
                                  </span>
                                  <span class="indicator-progress">
                                    <span class="spinner-border spinner-border-sm align-middle"></span>
                                  </span>
                                </button>
                                <button class="btn btn-icon btn-light-danger w-65px" id="kt_file_manager_cancel_folder"
                                  @click="
                                  storeArvore.diretorioCancelar(
                                      instancia,
                                      index
                                    )
                                    ">
                                  <span class="indicator-label">
                                    <!--begin::Svg Icon | path: icons/duotune/arrows/arr088.svg-->
                                    <span class="svg-icon svg-icon-1">
                                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <rect opacity="0.5" x="7.05025" y="15.5356" width="12" height="2" rx="1"
                                          transform="rotate(-45 7.05025 15.5356)" fill="currentColor"></rect>
                                        <rect x="8.46447" y="7.05029" width="12" height="2" rx="1"
                                          transform="rotate(45 8.46447 7.05029)" fill="currentColor"></rect>
                                      </svg>
                                    </span>
                                    <!--end::Svg Icon-->
                                  </span>
                                  <span class="indicator-progress">
                                    <span class="spinner-border spinner-border-sm align-middle"></span>
                                  </span>
                                </button>
                              </div>
                              <div v-if="item.erroMensagem && item.erroMensagem !== ''
                              " class="invalid-feedback text-start ps-12" :class="{
                                'd-block':
                                  item.erroMensagem &&
                                  item.erroMensagem !== '',
                              }">
                                {{ item.erroMensagem }}
                              </div>
                            </div>

                            <div v-if="item.status == 'renomear'">
                              <div class="d-flex">
                                <span class="svg-icon svg-icon-2x svg-icon-primary me-3 align-self-center"
                                  v-if="!item.isArquivo">
                                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none">
                                    <path opacity="0.3" d="M10 4H21C21.6 4 22 4.4 22 5V7H10V4Z" fill="currentColor">
                                    </path>
                                    <path
                                      d="M9.2 3H3C2.4 3 2 3.4 2 4V19C2 19.6 2.4 20 3 20H21C21.6 20 22 19.6 22 19V7C22 6.4 21.6 6 21 6H12L10.4 3.60001C10.2 3.20001 9.7 3 9.2 3Z"
                                      fill="currentColor"></path>
                                  </svg>
                                </span>
                                <span class="svg-icon svg-icon-2x svg-icon-primary me-3 align-self-center"
                                  v-if="item.isArquivo">
                                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none">
                                    <path opacity="0.3"
                                      d="M19 22H5C4.4 22 4 21.6 4 21V3C4 2.4 4.4 2 5 2H14L20 8V21C20 21.6 19.6 22 19 22Z"
                                      fill="currentColor"></path>
                                    <path d="M15 8H20L14 2V7C14 7.6 14.4 8 15 8Z" fill="currentColor"></path>
                                  </svg>
                                </span>
                                <input type="text" placeholder="Novo nome" class="form-control me-3" v-model="item.nome"
                                  @input="delete item.erroMensagem"
                                  @keyup="
                                    enterRenomear($event, instancia, index)
                                    " />
                                <button class="btn btn-icon btn-light-primary me-3 w-65px" @click="
                                  storeArvore.renomearSalvar(
                                    instancia,
                                    index
                                  )
                                  ">
                                  <span class="indicator-label">
                                    <!--begin::Svg Icon | path: icons/duotune/arrows/arr085.svg-->
                                    <span class="svg-icon svg-icon-1">
                                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path
                                          d="M9.89557 13.4982L7.79487 11.2651C7.26967 10.7068 6.38251 10.7068 5.85731 11.2651C5.37559 11.7772 5.37559 12.5757 5.85731 13.0878L9.74989 17.2257C10.1448 17.6455 10.8118 17.6455 11.2066 17.2257L18.1427 9.85252C18.6244 9.34044 18.6244 8.54191 18.1427 8.02984C17.6175 7.47154 16.7303 7.47154 16.2051 8.02984L11.061 13.4982C10.7451 13.834 10.2115 13.834 9.89557 13.4982Z"
                                          fill="currentColor"></path>
                                      </svg>
                                    </span>
                                    <!--end::Svg Icon-->
                                  </span>
                                  <span class="indicator-progress">
                                    <span class="spinner-border spinner-border-sm align-middle"></span>
                                  </span>
                                </button>
                                <button class="btn btn-icon btn-light-danger w-65px" @click="
                                  storeArvore.renomearCancelar(
                                    instancia,
                                    index
                                  )
                                  ">
                                  <span class="indicator-label">
                                    <!--begin::Svg Icon | path: icons/duotune/arrows/arr088.svg-->
                                    <span class="svg-icon svg-icon-1">
                                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <rect opacity="0.5" x="7.05025" y="15.5356" width="12" height="2" rx="1"
                                          transform="rotate(-45 7.05025 15.5356)" fill="currentColor"></rect>
                                        <rect x="8.46447" y="7.05029" width="12" height="2" rx="1"
                                          transform="rotate(45 8.46447 7.05029)" fill="currentColor"></rect>
                                      </svg>
                                    </span>
                                    <!--end::Svg Icon-->
                                  </span>
                                  <span class="indicator-progress">
                                    <span class="spinner-border spinner-border-sm align-middle"></span>
                                  </span>
                                </button>
                              </div>
                              <div v-if="item.erroMensagem && item.erroMensagem !== ''
                              " class="invalid-feedback text-start ps-12" :class="{
                                'd-block':
                                  item.erroMensagem &&
                                  item.erroMensagem !== '',
                              }">
                                {{ item.erroMensagem }}
                              </div>
                            </div>
                          </div>
                        </td>
                        <td class="pt-2 pb-1 ps-3" v-if="!item.status">
                          <div class="d-flex align-items-center">
                            <span class="me-2" v-if="!item.isArquivo">
                              <i :class="getIconClass(item.isArquivo ? item.tipo : 'diretorio')"
                                :style="{ color: getIconColor(item.isArquivo ? item.tipo : 'diretorio'), fontSize: '20px' }"></i>
                            </span>
                            <span class="me-2" v-if="item.isArquivo">
                              <i :class="getIconClass(item.isArquivo ? item.tipo : 'diretorio')"
                                :style="{ color: getIconColor(item.isArquivo ? item.tipo : 'diretorio'), fontSize: '20px' }"></i>
                            </span>
                            <div class="text-start">
                              <div class="text-dark fw-bolder text-hover-primary fs-7 prevent-select">
                                {{ item.nome + (item.tipo ? item.tipo : '') }}
                              </div>
                              <div class="text-dark text-hover-primary fs-8 prevent-select"
                                v-if="funcao == 'pesquisa-global' && !item.isDiretorioPai">
                                {{ storeArvore?.instancias[instancia]?.filtroCompartilhamentoDados == null ?  item.fullPath : item.fullPath.replace(storeArvore?.instancias[instancia]?.filtroCompartilhamentoDados.diretorio.fullPath + "/","/" + storeArvore?.instancias[instancia]?.filtroCompartilhamentoDados.nome + "/") }}
                              </div>
                            </div>
                          </div>
                        </td>
                        <td class="text-start pt-2 pb-1 ps-2"
                          v-if="(funcao == 'padrao' || funcao == 'pesquisa-global') && !item.status">
                          <div class="">
                            <div class="text-muted fw-bold d-block fs-7 prevent-select">
                              {{
                                item.tamanho > 0
                                  ? $funcoes.tamanhoTexto(item.tamanho)
                                  : item.tamanho
                              }}
                            </div>
                          </div>
                        </td>
                        <td class="text-start pt-2 pb-1 ps-2"
                          v-if="(funcao == 'padrao' || funcao == 'pesquisa-global') && !item.status">
                          <div class="">
                            <div class="text-muted fw-bold d-block fs-7 prevent-select">
                              {{
                                $funcoes.formatarDataHora(
                                  item.dataAlteracao
                                    ? item.dataAlteracao
                                    : item.data
                                )
                              }}
                            </div>
                          </div>
                        </td>
                        <td class="text-start pt-2 pb-1 ps-2"
                          v-if="(funcao == 'padrao' || funcao == 'pesquisa-global') && !item.status &&
                            storeArvore?.instancias[instancia]?.view == 'excluidos'">
                          <div class="">
                            <div class="text-muted fw-bold d-block fs-7 prevent-select">
                              {{
                                item.dataExclusao
                                  ? $funcoes.formatarDataHora(item.dataExclusao)
                                  : "-"
                              }}
                            </div>
                          </div>
                        </td>
                        <td class="text-start pt-2 pb-1 ps-2"
                          v-if="(funcao == 'padrao' || funcao == 'pesquisa-global') && !item.status &&
                            storeArvore?.instancias[instancia]?.view == 'excluidos'">
                          <div class="">
                            <div class="text-muted fw-bold d-block fs-7 prevent-select">
                              {{ item.usuarioExclusao && storeAuth.usuarios[item.usuarioExclusao] ? storeAuth.usuarios[item.usuarioExclusao].nome : "-" }}
                            </div>
                          </div>
                        </td>
                        <td class="text-start pt-2 pb-1 ps-2"
                          v-if="(funcao == 'padrao' || funcao == 'pesquisa-global') && !item.status">
                          <div class="text-muted fw-bold d-block fs-7 prevent-select">
                            {{ item.isArquivo ? item.tipo : "DIR" }}
                          </div>
                        </td>
                        <td class="text-start pt-2 pb-1 ps-2" v-if="(funcao == 'padrao' || funcao == 'pesquisa-global') &&
                          !item.status &&
                          storeArvore?.instancias[instancia]?.tipo ==
                          'remoto' &&
                          (storeArvore?.instancias[instancia]?.view ==
                            'diretorio' ||
                            storeArvore?.instancias[instancia]?.view ==
                            'compartilhamentos' ||
                            storeArvore?.instancias[instancia]?.view ==
                            'pesquisa' ||
                            storeArvore?.instancias[instancia]?.view ==
                            'excluidos')
                        ">
                          <div
                            class="text-muted fw-bold d-block fs-7 prevent-select d-flex justify-content-start align-items-center">
                            <div class="me-2">
                              {{
                                item.versoesQuantidade !== undefined
                                  ? item.versoesQuantidade
                                  : (item.versoes ? Object.keys(item.versoes).length : "")
                              }}
                            </div>
                            <div v-if="item.isArquivo &&
                              item.statusTransferencia &&
                              item.statusTransferencia == 'concluido'
                            "
                              class="bullet bullet-dot bg-success h-6px w-6px me-2"></div>
                            <div v-if="item.usuario && storeAuth.usuarios[item.usuario]" class="text-muted fs-8">
                              {{ storeAuth.usuarios[item.usuario].nome }}
                            </div>
                            <div v-if="item.usuarioAlteracao && storeAuth.usuarios[item.usuarioAlteracao]" class="text-muted fs-8">
                              {{ storeAuth.usuarios[item.usuarioAlteracao].nome }}
                            </div>
                          </div>
                        </td>
                        <td class="pt-2 pb-1 text-start ps-2" v-if="(funcao == 'padrao' || funcao == 'pesquisa-global') &&
                          !item.status &&
                          storeArvore?.instancias[instancia]?.tipo ==
                          'remoto' &&
                          storeArvore?.instancias[instancia]?.view ==
                          'versoes'
                        ">
                          <div
                            class="text-muted fw-bold d-block fs-7 prevent-select d-flex justify-content-start align-items-center">
                            <div class="me-2">{{ item.versao }}</div>
                            <div v-if="item.isArquivo &&
                              item.statusTransferencia &&
                              item.statusTransferencia == 'concluido'
                            "
                              class="bullet bullet-dot bg-success h-6px w-6px me-2"></div>
                            <div v-if="!item.isDiretorioPai && item.usuario && storeAuth.usuarios[item.usuario]" class="text-muted fs-8">
                              {{ storeAuth.usuarios[item.usuario].nome }}
                            </div>
                            <div v-if="!item.isDiretorioPai && item.usuarioAlteracao && storeAuth.usuarios[item.usuarioAlteracao]" class="text-muted fs-8">
                              {{ storeAuth.usuarios[item.usuarioAlteracao].nome }}
                            </div>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>

                  <!-- Menu de contexto -->
                  <div v-if="menuContexto.mostrar" 
                    class="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold fs-7 w-200px py-4"
                    :style="{ position: 'fixed', top: menuContexto.y + 'px', left: menuContexto.x + 'px', zIndex: 9999, display: 'block' }"
                    @click.stop>
                    
                    <div class="menu-item px-3">
                      <a href="#" class="menu-link px-3" @click.prevent.stop="menuAtualizar">
                        <span class="menu-icon">
                          <i class="bi bi-arrow-clockwise fs-5"></i>
                        </span>
                        <span class="menu-title">Atualizar</span>
                      </a>
                    </div>
                    
                    <div class="menu-item px-3" v-if="storeArvore?.instancias[instancia]?.view !== 'excluidos' && storeArvore?.instancias[instancia]?.tipo == 'local'">
                      <a href="#" class="menu-link px-3" @click.prevent.stop="menuTransferir">
                        <span class="menu-icon">
                          <i class="bi bi-cloud-upload fs-5"></i>
                        </span>
                        <span class="menu-title">Transferir</span>
                      </a>
                    </div>
                    
                    <div class="separator my-2" v-if="storeArvore?.instancias[instancia]?.view !== 'excluidos'"></div>
                    
                    <div class="menu-item px-3" v-if="storeArvore?.instancias[instancia]?.view !== 'excluidos' && storeArvore.selecionadosQuantidade(instancia) > 0">
                      <a href="#" class="menu-link px-3" @click.prevent.stop="menuCopiar">
                        <span class="menu-icon">
                          <i class="bi bi-files fs-5"></i>
                        </span>
                        <span class="menu-title">Copiar</span>
                      </a>
                    </div>
                    
                    <div class="menu-item px-3" v-if="storeArvore?.instancias[instancia]?.view !== 'excluidos' && storeArvore.selecionadosQuantidade(instancia) > 0">
                      <a href="#" class="menu-link px-3" @click.prevent.stop="menuRecortar">
                        <span class="menu-icon">
                          <i class="bi bi-scissors fs-5"></i>
                        </span>
                        <span class="menu-title">Recortar</span>
                      </a>
                    </div>
                    
                    <div class="menu-item px-3" v-if="storeArvore?.instancias[instancia]?.view !== 'excluidos' && storeArvore.clipboard != null">
                      <a href="#" class="menu-link px-3" @click.prevent.stop="menuColar">
                        <span class="menu-icon">
                          <i class="bi bi-clipboard fs-5"></i>
                        </span>
                        <span class="menu-title">Colar</span>
                      </a>
                    </div>
                    
                    <div class="separator my-2" v-if="storeArvore?.instancias[instancia]?.view !== 'excluidos'"></div>
                    
                    <div class="menu-item px-3" v-if="storeArvore?.instancias[instancia]?.view !== 'excluidos' && $funcoes.appTipo() !== 'web' && storeArvore?.instancias[instancia]?.tipo == 'remoto' && storeArvore.selecionadosQuantidade(instancia) === 1 && storeArvore.isSelecionadoArquivo(instancia)">
                      <a href="#" class="menu-link px-3" @click.prevent.stop="menuAbrir">
                        <span class="menu-icon">
                          <i class="bi bi-box-arrow-up-right fs-5"></i>
                        </span>
                        <span class="menu-title">Abrir</span>
                      </a>
                    </div>
                    
                    <div class="menu-item px-3" v-if="storeArvore?.instancias[instancia]?.view !== 'excluidos' && storeArvore?.instancias[instancia]?.tipo == 'local' && storeArvore.selecionadosQuantidade(instancia) === 1">
                      <a href="#" class="menu-link px-3" @click.prevent.stop="menuAbrirLocal">
                        <span class="menu-icon">
                          <i class="bi bi-terminal fs-5"></i>
                        </span>
                        <span class="menu-title">Abrir</span>
                      </a>
                    </div>
                    
                    <div class="menu-item px-3" v-if="storeArvore?.instancias[instancia]?.view !== 'excluidos' && $funcoes.appTipo() === 'web' && storeArvore?.instancias[instancia]?.tipo !== 'local' && podeAbrirMenuContexto() && storeArvore.selecionadosQuantidade(instancia) === 1 && storeArvore.isSelecionadoArquivo(instancia)">
                      <a href="#" class="menu-link px-3" @click.prevent.stop="menuAbrirWeb">
                        <span class="menu-icon">
                          <i class="bi bi-youtube fs-5"></i>
                        </span>
                        <span class="menu-title">Abrir</span>
                      </a>
                    </div>
                    
                    <div class="menu-item px-3" v-if="storeArvore?.instancias[instancia]?.view !== 'excluidos' && podeDownloadMenuContexto() && storeArvore.selecionadosQuantidade(instancia) > 0">
                      <a href="#" class="menu-link px-3" @click.prevent.stop="menuDownload">
                        <span class="menu-icon">
                          <i class="bi bi-cloud-arrow-down fs-5"></i>
                        </span>
                        <span class="menu-title">Download</span>
                      </a>
                    </div>
                    
                    <div class="menu-item px-3" v-if="storeArvore?.instancias[instancia]?.view !== 'excluidos' && podeLinkMenuContexto() && storeArvore.selecionadosQuantidade(instancia) > 0">
                      <a href="#" class="menu-link px-3" @click.prevent.stop="menuLink">
                        <span class="menu-icon">
                          <i class="bi bi-link-45deg fs-5"></i>
                        </span>
                        <span class="menu-title">Link</span>
                      </a>
                    </div>
                    
                    <div class="separator my-2" v-if="storeArvore?.instancias[instancia]?.view !== 'excluidos' && ($funcoes.appTipo() === 'web' || podeDownloadMenuContexto() || podeLinkMenuContexto())"></div>
                    
                    <div class="menu-item px-3" v-if="storeArvore.selecionadosQuantidade(instancia) === 1">
                      <a href="#" class="menu-link px-3" @click.prevent.stop="menuRenomear">
                        <span class="menu-icon">
                          <i class="bi bi-pencil fs-5"></i>
                        </span>
                        <span class="menu-title">Renomear</span>
                      </a>
                    </div>
                    
                    <div class="menu-item px-3" v-if="storeArvore?.instancias[instancia]?.view !== 'excluidos' && storeArvore.selecionadosQuantidade(instancia) > 0">
                      <a href="#" class="menu-link px-3" @click.prevent.stop="menuExcluir">
                        <span class="menu-icon">
                          <i class="bi bi-trash fs-5"></i>
                        </span>
                        <span class="menu-title">Excluir</span>
                      </a>
                    </div>
                    
                    <div class="menu-item px-3" v-if="storeArvore?.instancias[instancia]?.view !== 'excluidos'">
                      <a href="#" class="menu-link px-3" @click.prevent.stop="menuNovaPasta">
                        <span class="menu-icon">
                          <i class="bi bi-folder-plus fs-5"></i>
                        </span>
                        <span class="menu-title">Nova Pasta</span>
                      </a>
                    </div>

                    <div class="menu-item px-3" v-if="storeArvore?.instancias[instancia]?.tipo == 'remoto' && storeArvore?.instancias[instancia]?.view !== 'versoes' && storeArvore?.instancias[instancia]?.funcao !== 'pesquisa-global'">
                      <a href="#" class="menu-link px-3" @click.prevent.stop="menuPropriedades">
                        <span class="menu-icon">
                          <i class="bi bi-info-circle fs-5"></i>
                        </span>
                        <span class="menu-title">Propriedades</span>
                      </a>
                    </div>
                    
                  </div>
                </div>
                <div class="paginacao" :class="{ 'd-none': funcao !== 'pesquisa-global' }">
                  <ComponentPaginacao ref="paginacao" :total="storeArvore?.instancias[instancia]?.itensTotal"
                    :limit="storeArvore?.instancias[instancia]?.itensPorPagina" :center="true"
                    :pagina="storeArvore?.instancias[instancia]?.itensPagina" :tipo="'props'"
                    @change-pagina="changePaginacao" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <NuvemConectarDialog ref="nuvemConectarDialog" :instancia="instancia" @dialog-off="onFecharDialogConectar()" />
    <ComponentUploadHtml ref="dialogUploadHtml" :instancia="instancia" />
    <LinkOpcoesDialog ref="dialogLinkOpcoes" :instancia="instancia" />
    <PropriedadesDialog ref="propriedadesDialog" :instancia="instancia" />
    <DiretorioListFiltroDialog ref="dialogDiretorioListFiltro" @dialog-on="$emit('dialog-on')" @dialog-off="
      $emit('dialog-off');
    " :instancia="instancia" />
    <DialogMensagem ref="dialogExcluir" titulo="Excluir"
      mensagem="Confirme caso deseje excluir o(s) item selecionado(s) ?" classBody="mx-5 mx-xl-15 my-1 text-center"
      @confirmar="storeArvore.excluir(instancia)" />
    <DialogMensagem ref="dialogExcluirPermanente" titulo="Excluir Permanentemente"
      mensagem="ATENÇÃO: Os itens selecionados serão excluídos permanentemente e não poderão ser recuperados. A exclusão será processada em segundo plano. Deseja continuar?"
      classBody="mx-5 mx-xl-15 my-1 text-center"
      @confirmar="excluirPermanente()" />
    <DialogMensagem ref="dialogRestaurar" titulo="Restaurar"
      mensagem="Confirme caso deseje restaurar o item selecionado ?" classBody="mx-5 mx-xl-15 my-1 text-center"
      @confirmar="restaurar()" />
    <DialogMensagem ref="dialogRestaurarMensagem" titulo="Restaurar" classBody="mx-5 mx-xl-15 my-1 text-center"
      tipo="erro" />
    <DialogExport ref="dialogExport" @dialog-on="$emit('dialog-on')" @dialog-off="$emit('dialog-off');" @exportar="exportar"/>
  </div>
</template>

<script>
//import Combo from "../../components/ComponentCombo.vue";
import { useAuthStore } from "@/stores/auth.js";
import { useStoreUpload } from "../stores/storeUpload";
import { useStoreArvore } from "../stores/storeArvore.js";

import DialogMensagem from "../components/ComponentDialogMensagem.vue";
import ComponentUploadHtml from "../components/ComponentUploadHtml.vue";

import NuvemConectarDialog from "./NuvemConectarDialog.vue";
import PropriedadesDialog from "./PropriedadesDialog.vue";

import Dialog from "../components/ComponentDialog.vue";
import ComponentPaginacao from "../components/ComponentPaginacao.vue";
import LinkOpcoesDialog from "./LinkOpcoesDialog.vue";

import DiretorioListFiltroDialog from "./DiretorioListFiltroDialog.vue";
import DialogExport from "../components/ComponentDialogExport.vue";
import DiretorioListToolbar from "./DiretorioListToolbar.vue";

//* Módulos Node.js para ambiente desktop (Electron)
var path;
var fs;

try {
  path = require("path");
  fs = require("fs");
} catch (errPath) {
  console.log('Módulos Node.js não disponíveis (ambiente web):', errPath);
}

export default {
  components: {
    ComponentPaginacao,
    NuvemConectarDialog,
    PropriedadesDialog,
    LinkOpcoesDialog,
    DialogExport,
    DialogMensagem,
    Dialog,
    ComponentUploadHtml,
    DiretorioListFiltroDialog,
    DiretorioListToolbar
  },

  props: {
    tipo: { type: String, default: "local" },
    instancia: { type: String, default: "padrao" },
    funcao: { type: String, default: "padrao" },
  },

  setup() {
    const storeAuth = useAuthStore();
    const storeUpload = useStoreUpload();
    const storeArvore = useStoreArvore();

    return { storeUpload, storeAuth, storeArvore };
  },

  data() {
    return {
      timerFiltroTexto: null,
      filtroTexto: "",
      itensRef: [],
      barraPath: "",
      ordem: "nome_ASC",
      menuContexto: {
        mostrar: false,
        x: 0,
        y: 0,
        item: null,
        indexItem: null
      },
      // Resize de colunas
      resizeState: {
        isResizing: false,
        startX: 0,
        startWidth: 0,
        columnIndex: null,
        handle: null,
        th: null,
        pointerId: null,
        usingPointerEvents: false,
        userSelectBackup: '',
        cursorBackup: '',
        preventSortClick: false,
        allColumns: [],
        originalWidths: []
      },
      // Drag and drop
      dragState: {
        isDragging: false,
        isDragOver: false,
        dragCounter: 0,
        sourceInstancia: null,
        draggedItems: []
      }
    };
  },

  async mounted() {

    var thisCall = this;

    //* Ajuste menu view
    setTimeout(function () {
      window.KTMenu.init();
      window.KTMenu.init();
    }, 500);

    //* Cria a arvore
    await this.storeArvore.criar(this.instancia, this.tipo, this.funcao == "pesquisa-global" ? false : true);

    //* Atualiza os dados da sessao
    this.storeAuth.atualizarSessao();

    //* Define a funcao da instancia
    this.storeArvore.instancias[this.instancia].funcao = this.funcao;

    //* Redimensiona o diretorio
    window.addEventListener(
      "resize",
      function (event) {
        thisCall.redimensionar();
      },
      true
    );

    setTimeout(function () {
      thisCall.redimensionar();
    }, 200);

    //* Fecha menu de contexto ao clicar fora
    document.addEventListener("click", function (evt) {
      thisCall.menuContexto.mostrar = false;
    });

    document.addEventListener("click", function (evt) {
      if (thisCall.$refs.barraPathOpcao == null) {
        return;
      }

      if (
        evt.target.id == "barraPathOpcoesMostrar" ||
        evt.target.id == "barraPathOpcoesMostrarIcone" ||
        (evt.target.id == "inputBarraPath" &&
          evt.target.getAttribute("instancia") == thisCall.instancia)
      ) {
        return;
      }

      //* Verifica se clicou fora da barra de opcoes
      let itemComparar = document.getElementById(
        thisCall.$refs.barraPathOpcao.id
      ),
        targetItem = evt.target;

      //* Compara todos os elementos
      do {
        if (targetItem == itemComparar) {
          return;
        }
        targetItem = targetItem.parentNode;
      } while (targetItem);

      //* Verifica se a instancia esta criada
      if (thisCall.storeArvore.instancias[thisCall.instancia]) {
        //* Esconde o menu de opcoes
        thisCall.storeArvore.instancias[
          thisCall.instancia
        ].barraPathOpcoesMostrar = false;
      }
    });
  },

  methods: {
    getIconClass(ext) {

      ext = ext == null ? "default" : ext;

      const icons = {
        ".pdf": "fa-solid fa-file-pdf",
        ".xlsx": "fa-solid fa-file-excel",
        ".xls": "fa-solid fa-file-excel",
        ".doc": "fa-solid fa-file-word",
        ".docx": "fa-solid fa-file-word",
        ".ppt": "fa-solid fa-file-powerpoint",
        ".pptx": "fa-solid fa-file-powerpoint",
        ".jpg": "fa-solid fa-file-image",
        ".jpeg": "fa-solid fa-file-image",
        ".png": "fa-solid fa-file-image",
        ".gif": "fa-solid fa-file-image",
        ".eps": "fa-solid fa-file-image",
        ".mp3": "fa-solid fa-file-audio",
        ".wav": "fa-solid fa-file-audio",
        ".mp4": "fa-solid fa-file-video",
        ".mov": "fa-solid fa-file-video",
        ".zip": "fa-solid fa-file-zipper",
        ".rar": "fa-solid fa-file-zipper",
        ".txt": "fa-solid fa-file-lines",
        ".js": "fa-solid fa-file-code",
        ".html": "fa-solid fa-file-code",
        ".css": "fa-solid fa-file-code",
        ".json": "fa-solid fa-file-code",
        "diretorio": "fa-solid fa-folder text-primary",
        "default": "fa-solid fa-file",
      };
      return icons[ext.toLowerCase()] || icons["default"];
    },
    getIconColor(ext) {

      ext = ext == null ? "default" : ext;

      const colors = {
        ".pdf": "#D32F2F",       // vermelho
        ".xlsx": "#2E7D32",      // verde
        ".xls": "#2E7D32",
        ".doc": "#1565C0",       // azul
        ".docx": "#1565C0",
        ".ppt": "#EF6C00",       // laranja
        ".pptx": "#EF6C00",
        ".jpg": "#6A1B9A",       // roxo
        ".jpeg": "#6A1B9A",
        ".png": "#6A1B9A",
        ".gif": "#6A1B9A",
        ".eps": "#6A1B9A",
        ".mp3": "#00897B",       // verde água
        ".wav": "#00897B",
        ".mp4": "#D84315",       // vermelho queimado
        ".mov": "#D84315",
        ".zip": "#5D4037",       // marrom
        ".rar": "#5D4037",
        ".txt": "#757575",       // cinza
        ".js": "#0277BD",        // azul claro
        ".html": "#0277BD",
        ".css": "#0277BD",
        ".json": "#0277BD",
        default: "#BDBDBD",   // cinza claro
      };
      return colors[ext.toLowerCase()] || colors["default"];
    },
    redimensionar() {
      if (this.funcao == "padrao") {
        var tamanhoFrame = 290;

        //* Caso seja a pesquisa, acerta o tamanho do frame
        if (this.storeArvore.instancias[this.instancia].view == "pesquisa") {
          tamanhoFrame = 345;
        }

        if (this.$refs.frameDiretorio) {
          this.$refs.frameDiretorio.style["max-height"] =
            window.innerHeight - tamanhoFrame + "px";
          this.$refs.frameDiretorio.style["min-height"] =
            window.innerHeight - tamanhoFrame + "px";
        }
      }
    },
    enterBarraIr(event) {
      //* Esconde o menu de opcoes
      this.storeArvore.instancias[
        this.instancia
      ].barraPathOpcoesMostrar = false;

      //* Abre o diretorio informado
      this.enterBarraIrManual(event, false);
    },
    enterBarraIrManual(event, manual = true) {
      if (event.keyCode === 13) {
        //* Verifica se continua o mesmo path
        if (
          this.storeArvore.instancias[this.instancia].barraPath ==
          this.storeArvore.instancias[this.instancia].barraPathAnterior &&
          manual == false
        ) {
          return;
        }

        if (this.$funcoes.appTipo() == "desktop") {
          //* Ajusta o path
          if (
            this.storeArvore.instancias[this.instancia].tipo == "local" &&
            this.storeArvore.instancias[this.instancia].barraPath.trim() !== ""
          ) {
            this.storeArvore.instancias[this.instancia].barraPath =
              path.resolve(
                this.storeArvore.instancias[this.instancia].barraPath
              );
          }
        }

        //* Carrega o path preenchido
        var barraPathValida =
          this.storeArvore.instancias[this.instancia].barraPath;

        //* Valida se contem barra no ultimo path
        if (
          barraPathValida !== "" &&
          (barraPathValida[barraPathValida.length - 1] == "/" ||
            barraPathValida[barraPathValida.length - 1] == "\\")
        ) {
          this.storeArvore.instancias[this.instancia].barraPath =
            barraPathValida.slice(0, -1);
        }

        //* Define para abrir o diretorio
        this.storeArvore.diretorioIr(
          this.instancia,
          this.storeArvore.instancias[this.instancia].barraPath,
          "",
          true
        );
      }
      event.stopPropagation();
    },

    blurBarraIr(event) {
      //* Verifica se continua o mesmo path
      if (
        this.storeArvore.instancias[this.instancia].barraPath ==
        this.storeArvore.instancias[this.instancia].barraPathAnterior
      ) {
        return;
      }

      //* Ajusta o path
      if (
        this.storeArvore.instancias[this.instancia].tipo == "local" &&
        this.storeArvore.instancias[this.instancia].barraPath.trim() !== ""
      ) {
        this.storeArvore.instancias[this.instancia].barraPath = path.resolve(
          this.storeArvore.instancias[this.instancia].barraPath
        );
      }

      //* Carrega o path preenchido
      var barraPathValida =
        this.storeArvore.instancias[this.instancia].barraPath;

      //* Valida se contem barra no ultimo path
      if (
        barraPathValida !== "" &&
        (barraPathValida[barraPathValida.length - 1] == "/" ||
          barraPathValida[barraPathValida.length - 1] == "\\")
      ) {
        this.storeArvore.instancias[this.instancia].barraPath =
          barraPathValida.slice(0, -1);
      }

      //* Define para abrir o diretorio
      this.storeArvore.diretorioIr(
        this.instancia,
        this.storeArvore.instancias[this.instancia].barraPath
      );

      event.stopPropagation();
    },

    enterDiretorioSalvar(event, instancia, indexItem, item) {
      if (event.keyCode === 13) {
        event.preventDefault();
        this.storeArvore.diretorioSalvar(instancia, indexItem, item);
      }
      event.stopPropagation();
    },
    enterRenomear(event, instancia, indexItem) {
      if (event.keyCode === 13) {
        event.preventDefault();
        this.storeArvore.renomearSalvar(instancia, indexItem);
      }
      event.stopPropagation();
    },
    // Métodos helper para condições do menu de contexto
    podeAbrirMenuContexto() {
      const instancia = this.storeArvore.instancias[this.instancia];
      if (!instancia) return false;
      
      const isViewDiretorio = instancia.view === 'diretorio';
      const isViewPesquisa = instancia.view === 'pesquisa';
      const isViewCompartilhamentos = instancia.view === 'compartilhamentos';
      const tipoUsuario = this.storeAuth?.sessao?.usuario?.tipoUsuario || '';
      
      const isViewDiretorioOuFiltro = isViewDiretorio || (isViewPesquisa && tipoUsuario === 'adminNuvem');
      const isViewCompartilhamentosOuFiltro = isViewCompartilhamentos || (isViewPesquisa && tipoUsuario !== 'adminNuvem');
      
      return isViewDiretorioOuFiltro || isViewCompartilhamentosOuFiltro;
    },
    podeDownloadMenuContexto() {
      const instancia = this.storeArvore.instancias[this.instancia];
      if (!instancia) return false;
      
      const isViewDiretorio = instancia.view === 'diretorio';
      const isViewPesquisa = instancia.view === 'pesquisa';
      const isViewVersoes = instancia.view === 'versoes';
      const isViewCompartilhamentos = instancia.view === 'compartilhamentos';
      const tipoUsuario = this.storeAuth?.sessao?.usuario?.tipoUsuario || '';
      const diretorioAtual = instancia.diretorioAtual || '';
      
      const isViewDiretorioOuFiltro = isViewDiretorio || (isViewPesquisa && tipoUsuario === 'adminNuvem');
      const isViewCompartilhamentosOuFiltro = isViewCompartilhamentos || (isViewPesquisa && tipoUsuario !== 'adminNuvem');
      const dentroCompartilhamento = isViewCompartilhamentos && diretorioAtual !== '';
      const dentroCompartilhamentoOuFiltro = isViewCompartilhamentosOuFiltro && diretorioAtual !== '';
      
      return isViewDiretorioOuFiltro || isViewVersoes || dentroCompartilhamento || dentroCompartilhamentoOuFiltro;
    },
    podeLinkMenuContexto() {
      const instancia = this.storeArvore.instancias[this.instancia];
      if (!instancia) return false;
      
      const isViewDiretorio = instancia.view === 'diretorio';
      const isViewCompartilhamentos = instancia.view === 'compartilhamentos';
      const diretorioAtual = instancia.diretorioAtual || '';
      const dentroCompartilhamento = isViewCompartilhamentos && diretorioAtual !== '';
      
      return instancia.tipo === 'remoto' && (isViewDiretorio || dentroCompartilhamento);
    },
    abrirMenuContexto(event, item, indexItem) {
      // Se o item clicado já está selecionado, mantém a seleção atual (para ações em múltiplos itens)
      if (this.storeArvore.isSelecionado(this.instancia, item._id)) {
        // Não faz nada, mantém a seleção como está
      } else {
        // Item não está selecionado
        if (event.ctrlKey) {
          // Ctrl pressionado: adiciona o item à seleção existente
          this.storeArvore.instancias[this.instancia].selecionadosIds.add(item._id);
          this.storeArvore.instancias[this.instancia].selecionadosIndex = indexItem;
        } else if (event.shiftKey && this.storeArvore.instancias[this.instancia].selecionadosIndex !== null) {
          // Shift pressionado: seleciona range
          this.storeArvore.selecionar(event, this.instancia, item, indexItem);
        } else {
          // Sem modificadores: limpa seleção e seleciona apenas este item
          this.storeArvore.instancias[this.instancia].selecionadosIds = new Set([item._id]);
          this.storeArvore.instancias[this.instancia].selecionadosIndex = indexItem;
        }
      }
      
      // Calcula posição do menu ajustando para não sair da tela
      this.posicionarMenu(event);
      this.menuContexto.item = item;
      this.menuContexto.indexItem = indexItem;
    },
    abrirMenuContextoTabela(event) {
      // Limpa a seleção quando clica com botão direito na área vazia
      this.storeArvore.instancias[this.instancia].selecionadosIds.clear();
      this.storeArvore.instancias[this.instancia].selecionadosIndex = null;
      
      // Calcula posição do menu ajustando para não sair da tela
      this.posicionarMenu(event);
      this.menuContexto.item = null;
      this.menuContexto.indexItem = null;
    },
    limparSelecaoAreaVazia(event) {
      // Verifica se o clique foi na área vazia (não em um item da tabela)
      // O clique deve ser diretamente no container ou na tabela, não em um TR
      const target = event.target;
      const isClickOnItem = target.closest('tr') && target.closest('tbody');
      
      if (!isClickOnItem) {
        // Limpa a seleção de todos os itens
        this.storeArvore.instancias[this.instancia].selecionadosIds.clear();
        this.storeArvore.instancias[this.instancia].selecionadosIndex = null;
      }
    },
    posicionarMenu(event) {
      const menuWidth = 200; // largura do menu em pixels (w-200px)
      const estimatedMenuHeight = 450; // altura máxima estimada do menu
      const windowWidth = window.innerWidth;
      const windowHeight = window.innerHeight;
      const padding = 10; // espaço de segurança das bordas
      
      let x = event.clientX;
      let y = event.clientY;
      
      // Ajusta X se o menu sair pela direita
      if (x + menuWidth > windowWidth - padding) {
        x = windowWidth - menuWidth - padding;
      }
      
      // Garante que não saia pela esquerda
      if (x < padding) {
        x = padding;
      }
      
      // Ajusta Y se o menu sair por baixo
      // Verifica se há espaço suficiente abaixo do cursor
      const spaceBelow = windowHeight - y;
      const spaceAbove = y;
      
      if (spaceBelow < estimatedMenuHeight && spaceAbove > spaceBelow) {
        // Abre para cima se há mais espaço acima
        y = Math.max(padding, y - estimatedMenuHeight);
      } else if (y + estimatedMenuHeight > windowHeight - padding) {
        // Ajusta para não sair pela parte de baixo
        y = windowHeight - estimatedMenuHeight - padding;
      }
      
      // Garante que não saia pela parte de cima
      if (y < padding) {
        y = padding;
      }
      
      this.menuContexto.mostrar = true;
      this.menuContexto.x = x;
      this.menuContexto.y = y;
    },
    menuAtualizar() {
      this.menuContexto.mostrar = false;
      this.storeArvore.atualizar(this.instancia);
    },
    menuTransferir() {
      this.menuContexto.mostrar = false;
      this.storeArvore.transferir(this.instancia);
    },
    menuCopiar() {
      if (this.storeArvore.selecionadosQuantidade(this.instancia) == 0) return;
      this.menuContexto.mostrar = false;
      this.storeArvore.copiar(this.instancia);
    },
    menuRecortar() {
      if (this.storeArvore.selecionadosQuantidade(this.instancia) == 0) return;
      this.menuContexto.mostrar = false;
      this.storeArvore.recortar(this.instancia);
    },
    menuColar() {
      if (this.storeArvore.clipboard == null) return;
      this.menuContexto.mostrar = false;
      this.storeArvore.colar(this.instancia);
    },
    menuAbrir() {
      if (this.storeArvore.selecionadosQuantidade(this.instancia) !== 1 || !this.storeArvore.isSelecionadoArquivo(this.instancia)) return;
      this.menuContexto.mostrar = false;
      this.abrirArquivo();
    },
    menuAbrirLocal() {
      if (this.storeArvore.selecionadosQuantidade(this.instancia) !== 1) return;
      this.menuContexto.mostrar = false;
      this.storeArvore.abrirArquivoOS(this.instancia);
    },
    menuAbrirWeb() {
      if (this.storeArvore.selecionadosQuantidade(this.instancia) !== 1 || !this.storeArvore.isSelecionadoArquivo(this.instancia)) return;
      this.menuContexto.mostrar = false;
      this.abrirArquivo();
    },
    menuDownload() {
      if (this.storeArvore.selecionadosQuantidade(this.instancia) == 0) return;
      this.menuContexto.mostrar = false;
      this.storeArvore.downloadAnexo(this.instancia);
    },
    menuLink() {
      if (this.storeArvore.selecionadosQuantidade(this.instancia) == 0) return;
      this.menuContexto.mostrar = false;
      this.abrirDialogLinkOpcoes();
    },
    menuRenomear() {
      if (this.storeArvore.selecionadosQuantidade(this.instancia) !== 1) return;
      this.menuContexto.mostrar = false;
      this.storeArvore.renomear(this.instancia);
    },
    menuExcluir() {
      if (this.storeArvore.selecionadosQuantidade(this.instancia) == 0) return;
      this.menuContexto.mostrar = false;
      this.$refs.dialogExcluir.abrir();
    },
    menuNovaPasta() {
      this.menuContexto.mostrar = false;
      this.storeArvore.diretorioCriar(this.instancia);
    },
    menuPropriedades() {
      this.menuContexto.mostrar = false;
      
      // Verifica se tem algum item selecionado
      if (this.storeArvore.selecionadosQuantidade(this.instancia) === 1) {
        // Abre propriedades do item selecionado
        this.abrirPropriedades(this.instancia);
      } else {
        // Nenhum item selecionado - abre propriedades da pasta atual
        const diretorioAtual = this.storeArvore.instancias[this.instancia]?.diretorioAtual;
        
        if (!diretorioAtual || diretorioAtual === '' || diretorioAtual === '/') {
          // Pasta raiz
          this.abrirPropriedades(this.instancia, true);
        } else {
          // Pasta atual (não raiz)
          this.abrirPropriedades(this.instancia, false, diretorioAtual);
        }
      }
    },
    keyupFiltroTexto() {
      clearTimeout(this.timerFiltroTexto);

      const thisCall = this;

      this.timerFiltroTexto = setTimeout(function () {
        //obj.$refs.paginacao.pagina = 1;
        thisCall.storeArvore.carregarItens(thisCall.instancia);
      }, 300);
    },
    restaurarConfirmar() {
      this.$refs.dialogRestaurar.abrir();
    },
    restaurar() {
      var thisCall = this;

      //* Verifica se esta visualizando as versoes
      if (this.storeArvore.instancias[this.instancia].view == "versoes") {
        this.storeArvore.restaurarVersao(this.instancia);

        //* Verifica se esta visualizando as versoes
      } else if (
        this.storeArvore.instancias[this.instancia].view == "excluidos"
      ) {
        //* Restaura os itens excluidos
        this.storeArvore
          .restaurarExcluido(this.instancia)
          .then(function (resultRestaurarExcluido) {
            //* Verifica se restaurou os arquivos
            if (resultRestaurarExcluido !== "") {
              thisCall.$refs.dialogRestaurarMensagem.mensagemCustomizada =
                resultRestaurarExcluido;
              thisCall.$refs.dialogRestaurarMensagem.abrir();
            }
          });
      }
    },
    excluirItem() {
      this.$refs.dialogExcluir.abrir();
    },
    excluirPermanenteConfirmar() {
      this.$refs.dialogExcluirPermanente.abrir();
    },
    excluirPermanente() {
      this.storeArvore.excluirPermanentemente(this.instancia);
    },
    abrirNuvemConectarDialog() {
      this.$emit("dialog-on");
      this.$refs.nuvemConectarDialog.abrir();
    },
    abrirPropriedades(instancia, diretorioRoot = false, _id = null) {
      //* Detecta se é arquivo
      let isArquivo = false;
      if (!diretorioRoot && _id === null) {
        // Quando não tem _id específico, busca dos itens selecionados
        const itensSelecionados = this.storeArvore.getSelecionadosItens(instancia);
        console.log('abrirPropriedades - itensSelecionados:', itensSelecionados);
        if (itensSelecionados.length > 0) {
          const itemSelecionado = itensSelecionados[0];
          if (itemSelecionado.isArquivo === true) {
            isArquivo = true;
          }
          // Se não foi passado _id mas tem item selecionado, usa o _id dele
          _id = itemSelecionado._id;
        }
      } else if (!diretorioRoot && _id !== null) {
        // Quando tem _id específico, busca o item na lista atual para verificar se é arquivo
        const item = this.storeArvore.instancias[instancia].itens.find(i => i._id === _id);
        console.log('abrirPropriedades - item encontrado:', item);
        if (item && item.isArquivo === true) {
          isArquivo = true;
        }
        // Se não encontrou o item na lista atual, assume que é diretório (caso de diretorioAtual)
      }
      console.log('abrirPropriedades - chamando carregarItem:', { instancia, diretorioRoot, _id, isArquivo });
      this.$refs.propriedadesDialog.carregarItem(instancia, diretorioRoot, _id, isArquivo);
      this.$refs.propriedadesDialog.abrir();
    },
    abrirProcurar(instancia) {
      this.$emit("procurar", { instancia });
    },
    async clickColar(event) {
      await this.tooltipHide(event);
    },
    onFecharDialogConectar() {
      this.$emit("dialog-off");

      setTimeout(function () {
        //window.KTApp.init();
        //window.KTMenu.init();
        //window.KTApp.initBootstrapTooltips();
      }, 200);
    },
    async tooltipHide(item) {
      var valor = item.srcElement.attributes["aria-describedby"]?.value;

      if (valor !== null) {
        var tooltip = document.getElementById(valor);
        if (tooltip !== null) {
          tooltip.style.display = "none";
        }
      }
    },
    viewPesquisa() {
      var thisCall = this;

      this.storeArvore.instancias[this.instancia].filtroNome = "";
      this.storeArvore.instancias[this.instancia].view = "pesquisa";
      this.redimensionar();
      setTimeout(function () {
        thisCall.$refs.filtroNome.focus();
      }, 200);
    },
    selecaoMultipla(item, check) {
      this.storeArvore.selecaoMultipla(
        this.instancia,
        item,
        check.srcElement.checked
      );
    },
    pastaAnterior(instancia) {
      this.storeArvore.pastaAnterior(instancia);
    },
    pastaAcima(instancia) {
      this.storeArvore.pastaAcima(instancia);
    },
    barraPathOpcaoClique(item) {
      this.storeArvore.instancias[this.instancia].barraPath = item.path;
      this.enterBarraIrManual({ keyCode: 13, stopPropagation: () => { } }, true);
      this.storeArvore.instancias[
        this.instancia
      ].barraPathOpcoesMostrar = false;
    },
    downloadAnexo(instancia) {
      this.storeArvore.downloadAnexo(instancia);
    },
    abrirDialogUpload() {
      this.$refs.dialogUploadHtml.abrir();
    },
    abrirDialogLinkOpcoes(instancia) {
      this.$refs.dialogLinkOpcoes.abrir();
    },
    abrirArquivo() {
      const itensSelecionados = this.storeArvore.getSelecionadosItens(this.instancia);
      if (itensSelecionados.length > 0) {
        this.$emit("abrir-arquivo", { instancia: this.instancia, _id: itensSelecionados[0]._id });
      }
    },
    arvoreOrdem(colunaAsc, colunaDesc) {

      if (this.storeArvore.instancias[this.instancia].view == 'versoes') {
        return;
      }

      //* Altera a ordem da arvore
      this.storeArvore.instancias[this.instancia].ordem = (this.storeArvore.instancias[this.instancia].ordem == colunaAsc ? colunaDesc : colunaAsc)

      //* Recarrega os itens
      this.storeArvore.carregarItens(this.instancia);

    },
    handleHeaderClick(event, colunaAsc, colunaDesc) {
      if (this.resizeState.isResizing || this.resizeState.preventSortClick) {
        event.preventDefault();
        event.stopPropagation();
        return;
      }
      this.arvoreOrdem(colunaAsc, colunaDesc);
    },
    async abrirFiltro() {
      this.$refs.dialogDiretorioListFiltro.abrir();
    },
    async changePaginacao(novaPagina) {
      this.storeArvore.instancias[this.instancia].itensPagina = novaPagina;
      this.storeArvore.atualizar(this.instancia);
    },
    async duploCliqueItem(instancia, item)
    {
      // Verifica se o item está em edição
      if(item.status && item.status == "renomear")
      {
        return;
      }

      // Verifica se é pesquisa global
      if(this.$props.funcao == "pesquisa-global")
      {
        // Obtém a instância pai (definida quando o ProcurarDialog foi aberto)
        const instanciaPai = this.storeArvore.instancias[instancia]?.instanciaPai;
        
        if (!instanciaPai || !this.storeArvore.instancias[instanciaPai]) {
          return;
        }
        
        // Configura a instância pai para receber a navegação
        this.storeArvore.instancias[instanciaPai].funcao = "padrao";
        
        // Define a view correta baseado no filtro de excluídos
        if(this.storeArvore.instancias[instancia].filtroExcluidos === "true")
        {
          this.storeArvore.instancias[instanciaPai].view = "excluidos";
        } else {
          this.storeArvore.instancias[instanciaPai].view = this.storeAuth.sessao.usuario.tipoUsuario == "adminNuvem" ? "diretorio" : "compartilhamentos";        
        }

        // Define o caminho do diretório a navegar
        let diretorioPath = item.diretorioFullPath || item.fullPath || "/";

        // Verifica se está navegando para um compartilhamento
        if(this.storeAuth.sessao.usuario.tipoUsuario == 'usuarioNuvem' && 
           this.storeArvore.instancias[instancia].filtroCompartilhamentoDados)
        {
          diretorioPath = diretorioPath.replace(
            this.storeArvore.instancias[instancia].filtroCompartilhamentoDados.diretorio.fullPath, 
            "/" + this.storeArvore.instancias[instancia].filtroCompartilhamentoDados.nome
          );
        }

        // Navega para o diretório do arquivo na instância pai usando diretorioIr
        this.storeArvore.diretorioIr(instanciaPai, diretorioPath, "", false);
        
        // Emite evento para fechar a dialog de pesquisa
        this.$emit("dialog-on");
      } else {
        // Navegação normal (não é pesquisa global)
        this.storeArvore.navegarArvore(instancia, item);
      }
    },
    scrollToItem(index) {
      const element = this.itensRef[index];
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
      }
    },
    exportarAbrir()
    {
      this.$refs.dialogExport.abrir();
    },
    exportar(opcoes)
    { 
      this.storeArvore.atualizar(this.instancia, {export: true, exportFormato:opcoes.formato})
    },
    // ========================================
    // Métodos de Drag and Drop
    // ========================================
    handleDragEnter(event) {
      // Não permite drag durante visualização de versões
      if (this.storeArvore?.instancias[this.instancia]?.view === 'versoes') {
        return;
      }
      this.dragState.dragCounter++;
      this.dragState.isDragOver = true;
    },
    handleDragOver(event) {
      // Não permite drag durante visualização de versões
      if (this.storeArvore?.instancias[this.instancia]?.view === 'versoes') {
        event.dataTransfer.dropEffect = 'none';
        return;
      }
      event.preventDefault();
      // Define o efeito de drop baseado na origem
      if (event.dataTransfer) {
        // Verifica se é um drop de arquivos do sistema ou de outra instância
        const types = event.dataTransfer.types;
        if (types.includes('Files')) {
          event.dataTransfer.dropEffect = 'copy';
        } else if (types.includes('application/x-enuve-items')) {
          event.dataTransfer.dropEffect = 'move';
        }
      }
    },
    handleDragLeave(event) {
      // Não permite drag durante visualização de versões
      if (this.storeArvore?.instancias[this.instancia]?.view === 'versoes') {
        return;
      }
      this.dragState.dragCounter--;
      if (this.dragState.dragCounter === 0) {
        this.dragState.isDragOver = false;
      }
    },
    async handleDrop(event) {
      event.preventDefault();
      this.dragState.isDragOver = false;
      this.dragState.dragCounter = 0;

      // Não permite drop durante visualização de versões
      if (this.storeArvore?.instancias[this.instancia]?.view === 'versoes') {
        return;
      }

      // Verifica se é drop de arquivos do Windows/Sistema
      if (event.dataTransfer?.files?.length > 0) {
        await this.handleFileDrop(event.dataTransfer.files, event.dataTransfer.items);
        return;
      }

      // Verifica se é drop de itens de outra instância
      const transferData = event.dataTransfer?.getData('application/x-enuve-items');
      if (transferData) {
        try {
          const data = JSON.parse(transferData);
          await this.handleInstanceDrop(data);
        } catch (err) {
          console.error('Erro ao processar drop:', err);
        }
      }
    },
    async handleFileDrop(files, items) {
      const tipo = this.storeArvore?.instancias[this.instancia]?.tipo;
      const view = this.storeArvore?.instancias[this.instancia]?.view;
      const appTipo = this.$funcoes.appTipo();

      // Só permite drop em views que suportam upload/cópia
      if (view !== 'diretorio' && view !== 'compartilhamentos') {
        console.log('Drop não permitido nesta view');
        return;
      }

      // Se for ambiente desktop, usa a fila de transferência
      if (appTipo === 'desktop') {
        await this.handleDesktopFileDrop(files, tipo);
      } else {
        // Ambiente web - abre dialog de upload
        if (tipo === 'remoto') {
          await this.handleWebUpload(files, items);
        }
      }
    },
    async handleWebUpload(files, items) {
      // Processa os items ANTES de abrir o dialog (items expiram após o evento)
      let processedFiles = null;
      
      if (items && items.length > 0 && this.$refs.dialogUploadHtml?.processDataTransferItems) {
        try {
          processedFiles = await this.$refs.dialogUploadHtml.processDataTransferItems(Array.from(items));
        } catch (err) {
          console.error('Erro ao processar items:', err);
          processedFiles = Array.from(files);
        }
      } else {
        processedFiles = Array.from(files);
      }
      
      // Abre o dialog de upload e passa os arquivos já processados
      if (this.$refs.dialogUploadHtml) {
        this.$refs.dialogUploadHtml.abrir();
        // Aguarda o dialog abrir
        await this.$nextTick();
        
        // Passa os arquivos processados
        if (processedFiles && processedFiles.length > 0 && this.$refs.dialogUploadHtml.selecionarItens) {
          this.$refs.dialogUploadHtml.selecionarItens(processedFiles);
        }
      }
    },
    async handleDesktopFileDrop(files, tipoDestino) {
      // Para ambiente desktop (Electron), usa a fila de transferência igual ao botão Transferir
      
      // Verifica se os módulos Node.js estão disponíveis
      if (!fs || !path) {
        console.error('Módulos fs/path não disponíveis no ambiente');
        return;
      }
      
      // Coleta os itens arrastados do sistema
      const itensParaTransferir = [];
      
      for (let i = 0; i < files.length; i++) {
        const file = files[i];
        
        // Em ambiente Electron, files[i].path contém o caminho completo do arquivo
        const filePath = file.path;
        
        if (!filePath) {
          console.log('Arquivo sem path:', file.name);
          continue;
        }

        console.log('Processando arquivo arrastado:', filePath);
        
        // Verifica se é arquivo ou diretório usando fs
        let isArquivo = true;
        let tipo = '';
        
        try {
          const stats = fs.statSync(filePath);
          isArquivo = stats.isFile();
        } catch (err) {
          console.error('Erro ao verificar arquivo:', filePath, err);
          continue;
        }

        if (isArquivo) {
          // Extrai extensão do arquivo
          const lastDot = file.name.lastIndexOf('.');
          if (lastDot > 0) {
            tipo = file.name.substring(lastDot);
          }
          const nome = lastDot > 0 ? file.name.substring(0, lastDot) : file.name;
          
          itensParaTransferir.push({
            _id: filePath,
            fullPath: filePath,
            nome: nome,
            tipo: tipo,
            isArquivo: true,
            tamanho: file.size
          });
          
          console.log('Arquivo adicionado:', { nome, tipo, fullPath: filePath });
        } else {
          // É um diretório
          itensParaTransferir.push({
            _id: filePath,
            fullPath: filePath,
            nome: file.name,
            tipo: '',
            isArquivo: false,
            tamanho: 0
          });
          
          console.log('Diretório adicionado:', { nome: file.name, fullPath: filePath });
        }
      }

      if (itensParaTransferir.length === 0) {
        console.log('Nenhum item válido para transferir');
        return;
      }

      console.log('Total de itens para transferir:', itensParaTransferir.length);

      // Usa a lógica de transferência da fila (igual ao botão Transferir)
      const filaId = await this.criarFilaTransferenciaExterna(itensParaTransferir, tipoDestino);
      
      if (filaId) {
        console.log('Fila criada com sucesso:', filaId);
        // Inicia a transferência
        this.storeUpload.filasProximoArquivoTimer(1500);
      }
    },
    async criarFilaTransferenciaExterna(itens, tipoDestino) {
      // Cria uma fila de transferência para arquivos externos (do Windows)
      const storeAuth = this.storeAuth;
      const diretorioDestinoPath = this.storeArvore?.instancias[this.instancia]?.barraPath;
      const diretorioDestinoId = this.storeArvore?.instancias[this.instancia]?.diretorioAtual;

      if (!diretorioDestinoPath) {
        console.error('Diretório destino não definido');
        return null;
      }

      if (itens.length === 0) {
        console.error('Nenhum item para transferir');
        return null;
      }

      let filaId = null;

      // Obtém o diretório de origem a partir do primeiro item
      const primeiroItem = itens[0];
      const diretorioOrigemPath = path.dirname(primeiroItem.fullPath);

      if (tipoDestino === 'remoto') {
        // Upload: Local (Windows) → Remoto
        filaId = this.storeUpload.criarFila(
          'upload',
          storeAuth.apiNuvem(this.instancia),
          storeAuth.token[this.instancia] !== '' ? storeAuth.token[this.instancia] : null
        );

        // Define diretório principal usando o caminho real de origem
        const diretorioIdPrincipal = diretorioOrigemPath;
        
        this.storeUpload.criarFilaDiretorio(
          filaId,
          diretorioIdPrincipal,
          null,
          null,
          diretorioOrigemPath,
          'local',
          false,
          { caminhoParent: diretorioDestinoPath, diretorioParent: diretorioDestinoId }
        );

        this.storeUpload.fila[filaId].subdiretorios[diretorioIdPrincipal] = true;

        // Adiciona cada item na fila
        for (const item of itens) {
          if (item.isArquivo) {
            await this.storeUpload.uploadArquivo(
              filaId,
              item.nome + item.tipo,
              item.fullPath,
              diretorioDestinoId,
              diretorioDestinoPath
            );
          } else {
            // Diretório
            this.storeUpload.criarFilaDiretorio(
              filaId,
              item.fullPath,
              null,
              null,
              item.fullPath,
              'local',
              true,
              { caminhoParent: diretorioDestinoPath, diretorioParent: diretorioDestinoId }
            );
            this.storeUpload.fila[filaId].subdiretorios[item.fullPath] = true;
          }
        }

        // Finaliza carregamento da fila
        this.storeUpload.fila[filaId].carregando = false;

      } else if (tipoDestino === 'local') {
        // Cópia: Local (Windows) → Local (outra pasta)
        filaId = this.storeUpload.criarFila('copia', null, null);

        // Define diretório principal usando o caminho real de origem
        const diretorioIdPrincipal = diretorioOrigemPath;
        
        this.storeUpload.criarFilaDiretorio(
          filaId,
          diretorioIdPrincipal,
          null,
          null,
          diretorioOrigemPath,
          'local',
          false,
          { caminhoParent: diretorioDestinoPath, diretorioParent: '' }
        );

        this.storeUpload.fila[filaId].subdiretorios[diretorioIdPrincipal] = true;

        // Adiciona cada item na fila de cópia
        for (const item of itens) {
          if (item.isArquivo) {
            const destinoCompleto = path.join(diretorioDestinoPath, item.nome + item.tipo);
            await this.storeUpload.copiaArquivoLocal(filaId, item.fullPath, destinoCompleto);
          } else {
            // Para diretórios, copia recursivamente
            this.storeUpload.criarFilaDiretorio(
              filaId,
              item.fullPath,
              null,
              null,
              item.fullPath,
              'local',
              true,
              { caminhoParent: diretorioDestinoPath, diretorioParent: '' }
            );
            this.storeUpload.fila[filaId].subdiretorios[item.fullPath] = true;
          }
        }

        // Finaliza carregamento da fila
        if (this.storeUpload.fila[filaId]) {
          this.storeUpload.fila[filaId].carregando = false;
        }
        
        // Atualiza a lista após a cópia
        setTimeout(() => {
          this.storeArvore.atualizar(this.instancia);
        }, 2000);
      }

      return filaId;
    },
    async handleInstanceDrop(data) {
      const sourceInstancia = data.sourceInstancia;
      const targetInstancia = this.instancia;

      // Não permite drop na mesma instância
      if (sourceInstancia === targetInstancia) {
        console.log('Drop na mesma instância ignorado');
        return;
      }

      // Verifica se a instância de origem existe
      if (!this.storeArvore?.instancias[sourceInstancia]) {
        console.error('Instância de origem não encontrada');
        return;
      }

      // Usa o método transferir do storeArvore
      // Restaura os itens selecionados que foram arrastados
      this.storeArvore.instancias[sourceInstancia].selecionadosIds = new Set(data.items.map(item => item._id));

      // Executa a transferência
      await this.storeArvore.transferir(sourceInstancia);

      // Restaura a seleção original (opcional)
      // this.storeArvore.instancias[sourceInstancia].selecionados = itensOriginais;
    },
    handleRowDragStart(event, item, indexItem) {
      // Não permite arrastar durante visualização de versões
      if (this.storeArvore?.instancias[this.instancia]?.view === 'versoes') {
        event.preventDefault();
        return;
      }
      // Não permite arrastar diretório pai ou itens em edição
      if (item.isDiretorioPai || item.status) {
        event.preventDefault();
        return;
      }

      this.dragState.isDragging = true;
      this.dragState.sourceInstancia = this.instancia;

      // Se o item não está selecionado, seleciona apenas ele
      if (!this.storeArvore.isSelecionado(this.instancia, item._id)) {
        this.storeArvore.instancias[this.instancia].selecionadosIds = new Set([item._id]);
        this.storeArvore.instancias[this.instancia].selecionadosIndex = indexItem;
      }

      // Coleta todos os itens selecionados
      const itens = this.storeArvore.getSelecionadosItens(this.instancia);
      this.dragState.draggedItems = itens;

      // Define os dados de transferência
      const transferData = {
        sourceInstancia: this.instancia,
        sourceTipo: this.storeArvore?.instancias[this.instancia]?.tipo,
        items: itens
      };

      event.dataTransfer.setData('application/x-enuve-items', JSON.stringify(transferData));
      event.dataTransfer.effectAllowed = 'copyMove';

      // Cria uma imagem de drag customizada mostrando a quantidade de itens
      const dragImage = document.createElement('div');
      dragImage.className = 'drag-ghost';
      dragImage.innerHTML = `
        <i class="bi bi-files me-2"></i>
        <span>${itens.length} ${itens.length === 1 ? 'item' : 'itens'}</span>
      `;
      dragImage.style.cssText = `
        position: absolute;
        top: -1000px;
        left: -1000px;
        background: #0d6efd;
        color: white;
        padding: 8px 16px;
        border-radius: 6px;
        font-size: 14px;
        font-weight: 500;
        display: flex;
        align-items: center;
        box-shadow: 0 4px 12px rgba(0,0,0,0.2);
      `;
      document.body.appendChild(dragImage);
      event.dataTransfer.setDragImage(dragImage, 0, 0);

      // Remove o elemento após um pequeno delay
      setTimeout(() => {
        document.body.removeChild(dragImage);
      }, 0);
    },
    handleRowDragEnd(event) {
      this.dragState.isDragging = false;
      this.dragState.sourceInstancia = null;
      this.dragState.draggedItems = [];
    },
    // ========================================
    // Métodos de resize de colunas
    // ========================================
    iniciarResize(event, columnIndex) {
      if (event.type === 'mousedown' && typeof window !== 'undefined' && window.PointerEvent) {
        return;
      }

      const handle = event.currentTarget || event.target;
      const th = handle?.closest('th');
      if (!th) {
        return;
      }

      // Busca todas as colunas do cabeçalho
      const headerRow = th.closest('tr');
      const allThs = headerRow ? Array.from(headerRow.querySelectorAll('th')) : [];
      
      // Captura as larguras atuais de TODAS as colunas
      const widths = allThs.map(col => col.offsetWidth);
      
      // Aplica as larguras em pixels para TODAS as colunas ANTES de começar o resize
      // Isso "trava" o layout e evita reajustes
      allThs.forEach((col, idx) => {
        col.style.width = widths[idx] + 'px';
        col.style.minWidth = widths[idx] + 'px';
        col.style.maxWidth = widths[idx] + 'px';
      });

      // Guarda referências para restaurar depois se necessário
      this.resizeState.allColumns = allThs;
      this.resizeState.originalWidths = widths;

      this.resizeState.isResizing = true;
      this.resizeState.preventSortClick = true;
      this.resizeState.startX = event.clientX;
      this.resizeState.startWidth = widths[allThs.indexOf(th)];
      this.resizeState.columnIndex = columnIndex;
      this.resizeState.handle = handle;
      this.resizeState.th = th;
      this.resizeState.pointerId = typeof event.pointerId === 'number' ? event.pointerId : null;
      this.resizeState.usingPointerEvents = event.type.startsWith('pointer');
      this.resizeState.userSelectBackup = document.body.style.userSelect;
      this.resizeState.cursorBackup = document.body.style.cursor;

      handle.classList.add('resizing');

      document.body.style.userSelect = 'none';
      document.body.style.cursor = 'col-resize';

      if (this.resizeState.usingPointerEvents && this.resizeState.pointerId !== null && handle.setPointerCapture) {
        handle.setPointerCapture(this.resizeState.pointerId);
        handle.addEventListener('pointermove', this.executarResize);
        handle.addEventListener('pointerup', this.finalizarResize);
        handle.addEventListener('pointercancel', this.finalizarResize);
      } else if (typeof window !== 'undefined') {
        window.addEventListener('mousemove', this.executarResize);
        window.addEventListener('mouseup', this.finalizarResize);
      }

      event.preventDefault();
    },
    executarResize(event) {
      if (!this.resizeState.isResizing || !this.resizeState.th) return;

      if (this.resizeState.usingPointerEvents && this.resizeState.pointerId !== null && typeof event.pointerId === 'number' && event.pointerId !== this.resizeState.pointerId) {
        return;
      }

      event.preventDefault();

      // Calcula a diferença do movimento do mouse desde o início
      const diff = event.clientX - this.resizeState.startX;
      const newWidth = Math.max(50, this.resizeState.startWidth + diff);

      // Aplica diretamente sem throttle para melhor responsividade
      this.resizeState.th.style.width = newWidth + 'px';
      this.resizeState.th.style.minWidth = newWidth + 'px';
      this.resizeState.th.style.maxWidth = newWidth + 'px';
    },
    finalizarResize(event) {
      if (!this.resizeState.isResizing) return;

      if (this.resizeState.usingPointerEvents && this.resizeState.pointerId !== null && event && typeof event.pointerId === 'number' && event.pointerId !== this.resizeState.pointerId) {
        return;
      }

      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }

      this.resizeState.isResizing = false;

      if (this.resizeState.handle) {
        if (this.resizeState.usingPointerEvents && this.resizeState.pointerId !== null && this.resizeState.handle.releasePointerCapture) {
          try {
            this.resizeState.handle.releasePointerCapture(this.resizeState.pointerId);
          } catch (error) {
            // Ignora se o elemento já não estiver mais conectado
          }
        }
        this.resizeState.handle.classList.remove('resizing');
      }

      if (this.resizeState.usingPointerEvents && this.resizeState.handle) {
        this.resizeState.handle.removeEventListener('pointermove', this.executarResize);
        this.resizeState.handle.removeEventListener('pointerup', this.finalizarResize);
        this.resizeState.handle.removeEventListener('pointercancel', this.finalizarResize);
      } else if (typeof window !== 'undefined') {
        window.removeEventListener('mousemove', this.executarResize);
        window.removeEventListener('mouseup', this.finalizarResize);
      }

      document.body.style.userSelect = this.resizeState.userSelectBackup || '';
      document.body.style.cursor = this.resizeState.cursorBackup || '';

      // Limpa o estado
      this.resizeState.th = null;
      this.resizeState.handle = null;
      this.resizeState.pointerId = null;
      this.resizeState.usingPointerEvents = false;
      this.resizeState.allColumns = [];
      this.resizeState.originalWidths = [];
      setTimeout(() => {
        this.resizeState.preventSortClick = false;
      }, 0);
    }
  },
};
</script>

<style>
.frameDiretorioFixed {
  min-height: 400px;
  max-height: 400px;
  overflow: scroll
}

.bg-primary-light {
  background-color: #e0e0e0 !important;
}

.bg-hover-primary-light:hover {
  background-color: #e0e0e0 !important;
}

/* Tbody otimizado com v-memo para evitar re-renders desnecessários */

.table-resizable thead {
  display: table-header-group;
}

/* ========================================
   ESTILOS DO EXPLORADOR DE ARQUIVOS
   ======================================== */

/* Barra de Path */
.input-group .input-group-text {
  background: #f8f9fa;
  border: 1px solid #dee2e6;
  border-right: none;
  color: #6c757d;
}

.input-group .form-control {
  border: 1px solid #dee2e6;
  border-left: none;
  font-size: 0.875rem;
  padding: 0.5rem 0.75rem;
}

.input-group .form-control:focus {
  border-color: #86b7fe;
  box-shadow: none;
}

/* Tabela redimensionável */
.table-resizable {
  table-layout: auto;
  width: auto;
  min-width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  border: 1px solid #e9ecef;
  border-radius: 6px;
  overflow: hidden;
}

/* Header da tabela */
.table-resizable thead {
  position: sticky;
  top: 0;
  z-index: 10;
}

.table-resizable thead tr {
  background: #f1f3f5;
  border-bottom: 1px solid #dee2e6;
}

.table-resizable th {
  background: transparent;
  border-right: 1px solid #dee2e6;
  border-bottom: 1px solid #dee2e6;
  font-weight: 600;
  font-size: 0.8rem;
  color: #495057;
  padding: 8px 12px !important;
  transition: background-color 0.15s ease;
  white-space: nowrap;
  user-select: none;
}

.table-resizable th:last-child {
  border-right: none;
}

.table-resizable th:hover {
  background: #e9ecef;
}

.table-resizable th.cursor-pointer {
  cursor: pointer;
}

.table-resizable th.cursor-pointer:hover {
  background: #e2e6ea;
}

.table-resizable th .bi {
  margin-left: 4px;
  font-size: 0.75rem;
  color: #6c757d;
}

.table-resizable th .bi-sort-down-alt,
.table-resizable th .bi-sort-up {
  color: #0d6efd;
}

/* Células da tabela */
.table-resizable td {
  border-right: 1px solid #f1f3f5;
  border-bottom: 1px solid #f1f3f5;
  padding: 6px 12px !important;
  font-size: 0.875rem;
}

.table-resizable td:last-child {
  border-right: none;
}

.table-resizable tbody tr:last-child td {
  border-bottom: none;
}

/* Handle de redimensionamento */
.table th.resizable {
  position: relative;
  min-width: 50px;
}

.table th.resizable .resize-handle {
  position: absolute;
  right: -3px;
  top: 0;
  bottom: 0;
  width: 6px;
  cursor: col-resize;
  background: transparent;
  z-index: 100;
  touch-action: none;
}

.table th.resizable .resize-handle:hover {
  background: #0d6efd;
  opacity: 0.5;
}

.table th.resizable .resize-handle.resizing {
  background: #0d6efd;
  opacity: 0.8;
}

/* Scrollbar customizada */
.table-responsive::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}

.table-responsive::-webkit-scrollbar-track {
  background: transparent;
}

.table-responsive::-webkit-scrollbar-thumb {
  background: #909090;
  border-radius: 5px;
}

.table-responsive::-webkit-scrollbar-thumb:hover {
  background: #707070;
}

.table-responsive::-webkit-scrollbar-corner {
  background: transparent;
}

/* Firefox */
.table-responsive {
  scrollbar-width: thin;
  scrollbar-color: #909090 transparent;
}

/* ========================================
   HISTÓRICO DE PATHS
   ======================================== */

.path-input-group {
  position: relative;
}

.path-history-dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  z-index: 1000;
  background: #ffffff;
  border: 1px solid #dee2e6;
  border-top: none;
  border-radius: 0 0 6px 6px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  max-height: 300px;
  overflow: hidden;
}

.path-history-header {
  display: flex;
  align-items: center;
  padding: 8px 12px;
  background: #f8f9fa;
  border-bottom: 1px solid #e9ecef;
  font-size: 0.75rem;
  font-weight: 600;
  color: #6c757d;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.path-history-header .btn-close {
  font-size: 0.6rem;
  opacity: 0.5;
}

.path-history-header .btn-close:hover {
  opacity: 1;
}

.path-history-list {
  max-height: 250px;
  overflow-y: auto;
}

.path-history-item {
  display: flex;
  align-items: center;
  padding: 8px 12px;
  cursor: pointer;
  border-bottom: 1px solid #f1f3f5;
  transition: background-color 0.15s ease;
}

.path-history-item:last-child {
  border-bottom: none;
}

.path-history-item:hover {
  background: #e7f1ff;
}

.path-history-text {
  font-size: 0.875rem;
  color: #495057;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: left;
}

.path-history-item .bi-folder2 {
  flex-shrink: 0;
  color: #0d6efd;
}

.path-history-item:hover .path-history-text {
  color: #0d6efd;
}

/* Scrollbar do histórico */
.path-history-list::-webkit-scrollbar {
  width: 6px;
}

.path-history-list::-webkit-scrollbar-track {
  background: #f1f3f5;
}

.path-history-list::-webkit-scrollbar-thumb {
  background: #adb5bd;
  border-radius: 3px;
}

.path-history-list::-webkit-scrollbar-thumb:hover {
  background: #6c757d;
}

/* ========================================
   DRAG AND DROP
   ======================================== */

/* Área de drop ativa */
.table-responsive.drag-over {
  background: linear-gradient(135deg, rgba(13, 110, 253, 0.05) 0%, rgba(13, 110, 253, 0.1) 100%);
  border: 2px dashed #0d6efd !important;
  border-radius: 8px;
  transition: all 0.2s ease;
}

.table-responsive.drag-over::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(13, 110, 253, 0.03);
  pointer-events: none;
  z-index: 1;
  border-radius: 8px;
}

/* Linha sendo arrastada */
.table-resizable tbody tr.dragging {
  opacity: 0.6;
  background: #e7f1ff !important;
}

/* Linhas arrastáveis */
.table-resizable tbody tr[draggable="true"] {
  cursor: grab;
}

.table-resizable tbody tr[draggable="true"]:active {
  cursor: grabbing;
}

/* Ghost de drag customizado (fallback) */
.drag-ghost {
  position: fixed;
  pointer-events: none;
  z-index: 10000;
}

/* Indicador de drop zone */
.drop-indicator {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: rgba(13, 110, 253, 0.9);
  color: white;
  padding: 16px 24px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  z-index: 100;
}

.drop-indicator i {
  font-size: 20px;
}
</style>
